import React, { useEffect, useState, useRef } from "react";
import {
  Grid,
  Autocomplete,
  Box,
  Button,
  Checkbox,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  InputLabel,
  FormControl,
  MenuItem,
  Select,
  TextField,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Pagination,
  PaginationItem,
  Divider,
  SelectChangeEvent,
  InputAdornment,
  Tooltip,
} from "@mui/material";
import {
  Add,
  Delete,
  Download,
  FilterList,
  MoreVert,
  Search,
  Clear,
  FirstPage,
  LastPage,
  Remove,
  CloudUpload,
  Close,
  PhotoCamera,
} from "@mui/icons-material";
import { TrashOutline } from "react-ionicons";
import "../../../shared/components/Item.css";
import { styled } from "@mui/system";
import ImageIcon from "@mui/icons-material/Image";
import CloseIcon from "@mui/icons-material/Close";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import FormHelperText from "@mui/material/FormHelperText";
import { LocalizationProvider, DesktopDatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import {
  getEmployees,
  employeeSearchParams,
  createEmployee,
  uploadItemPhoto,
  deleteEmployee,
  updateEmployee,
  fetchEmployees,
  getEmployeeById,
  fetchEmployeePhotoBlob,
  fetchRoles,
  fetchVendors,
  createEmployeeWithAccount,
  deleteEmployeeByEmail,
  formatPositionDisplay,
  fetchOffices,
  assignRolesToUser,
  unassignRoleFromUser,
  getUserInfoByEmail,
} from "../services/employeeService.tsx";
import Swal from "sweetalert2";
import * as XLSX from "xlsx";
import LoadingOverlay from "../../../shared/components/LoadingOverlay.tsx";

interface Employee {
  id: string;
  name: string;
  nik: string;
  position: any[];
  division: string;
  office: string;
  status: string;
  employeeType: string;
  userId: string; // Tambahkan ini
  email: string; // Tambahkan ini
  bpjsKesehatan: number | null;
  bpjsTK: number | null;
  pTKPCategory: string;
  pph21: number | null;
  grossSalary: number | null;
  nettSalary: number | null;
}

interface Role {
  id: string;
  name: string;
  description?: string;
}

interface RoleOption {
  id: string;
  name: string;
  description?: string;
}

interface SelectedRole {
  id: string;
  name: string;
  selected: boolean;
}

interface Vendor {
  vendorId: string;
  vendorName: string; // Perbaiki typo dari vendorNameame
  vendorAddress: string;
  vendorContactNumber: string;
  vendorEmail: string;
  vendorType: string;
  vendorTaxId: string;
  vendorBankDetails: string;
  vendorStatus: string;
  photoVendor?: string; // Tambahkan field untuk foto
}

interface Office {
  officeId: string;
  officeName: string;
  officeAddress: string;
  latitude: string;
  longitude: string;
  region: string;
  province: string;
  city: string;
  district: string;
  managerName: string;
  contactNumber: string;
  officeEmail: string;
  officeType: string;
  file: File | null;
}

type PTKPCategory =
  | 'TK/0'
  | 'TK/1'
  | 'TK/2'
  | 'TK/3'
  | 'K/0'
  | 'K/1'
  | 'K/2'
  | 'K/3';

type CategoryTER = 'TER A' | 'TER B' | 'TER C';

const bankData = [
  "-",
  "Bank Rakyat Indonesia (BRI) - 002",
  "Bank Mandiri - 008",
  "Bank Negara Indonesia (BNI) - 009",
  "Bank Tabungan Negara (BTN) - 200",
  "Bank Syariah Indonesia (BSI) - 451",
  "Bank Central Asia (BCA) - 014",
  "Bank CIMB Niaga - 022",
  "Bank Danamon - 011",
  "Bank Permata - 013",
  "Bank Maybank Indonesia - 016",
  "Bank Panin - 019",
  "Bank OCBC NISP - 028",
  "Bank Sinarmas - 153",
  "Bank Mega - 426",
  "Bank KB Bukopin - 441",
  "Bank BTPN - 213",
  "Bank UOB Indonesia - 023",
  "Bank BCA Syariah - 536",
  "Bank Muamalat - 147",
  "Bank BTPN Syariah - 547",
  "Bank Victoria International - 566",
  "Bank Woori Saudara - 212",
  "Bank Jago - 542",
  "Bank Neo Commerce - 490",
  "Allo Bank - 567",
  "SeaBank - 535",
  "Bank Amar Indonesia - 531",
  "Bank Aladin Syariah - 947",
  "Bank Jenius (BTPN) - 213",
  "Bank Raya (BRI Agro) - 494",
  "Bank MNC Internasional - 485",
  "Bank Hana - 484",
  "Bank QNB Indonesia - 167",
  "Bank Mayora - 553",
  "Bank Index Selindo - 555",
  "Bank Sahabat Sampoerna - 523",
  "Bank Oke Indonesia - 526",
  "Bank Ina Perdana - 513",
  "Bank Ganesha - 161",
  "Bank Maspion - 157",
  "Bank Capital Indonesia - 054",
  "Bank Resona Perdania - 047",
  "Bank ICBC Indonesia - 164",
  "Bank JTrust Indonesia - 095",
  "Bank Artha Graha Internasional - 037",
  "Bank Commonwealth - 950",
  "Bank CTBC Indonesia - 949",
  "Bank of China - 069",
  "Standard Chartered Bank - 050",
  "Citibank - 031",
  "JP. Morgan Chase Bank, N.A. - 032",
  "Bank of America, N.A - 033",
  "Bank Mizuho Indonesia - 048",
  "Bank Sumitomo Mitsui Indonesia - 045",
  "The Bank of Tokyo Mitsubishi UFJ LTD - 042",
  "American Express Bank LTD - 030",
  "Bank DKI Jakarta - 111",
  "Bank Jabar Banten (BJB) - 110",
  "Bank BPD DIY - 112",
  "Bank Jateng - 113",
  "Bank Jatim - 114",
  "Bank Jambi - 115",
  "Bank Aceh - 116",
  "Bank Sumut - 117",
  "Bank Nagari (Sumbar) - 118",
  "Bank Riau Kepri - 119",
  "Bank Sumsel Babel - 120",
  "Bank Lampung - 121",
  "Bank Kalsel - 122",
  "Bank Kalbar - 123",
  "Bank Kaltimtara - 124",
  "Bank Kalteng - 125",
  "Bank Sulselbar - 126",
  "Bank SulutGo - 127",
  "Bank NTB - 128",
  "Bank BPD Bali - 129",
  "Bank NTT - 130",
  "Bank Maluku Malut - 131",
  "Bank Papua - 132",
  "Bank Bengkulu - 133",
  "Bank Sulteng - 134",
  "Bank Sultra - 135",
  "Bank Banten - 137",
];

const positionData = {
  Direksi: {
    Direksi: [
      "Direktur Utama",
      "Direktur Operasional dan Teknik",
      "Direktur Pengembangan Usaha",
      "Direktur Keuangan",
    ],
  },
  "Satuan Pengawas Internal": {
    "Satuan Pengawas Internal": [
      "Kepala Satuan Pengawas Internal",
      "Staf Satuan Pengawas Internal",
    ],
  },
  "Sekretaris Perusahaan": {
    "Sekretaris Perusahaan": [
      "Sekretaris Perusahaan",
      "Staf Sekretaris Perusahaan",
    ],
  },
  "Satuan K3 dan Sistem Manajemen": {
    "Satuan K3 dan Sistem Manajemen": [
      "Kepala Satuan K3 dan Sistem Manajemen",
      "Staf Kepala Satuan K3 dan Sistem Manajemen",
    ],
  },
  "Pengembangan Usaha": {
    "Pengembangan Usaha, Pemasaran, Teknologi Informasi dan Investasi": [
      "Kepala Divisi Pengembangan Usaha, Pemasaran, Teknologi Informasi dan Investasi",
      "Staf Ahli Teknologi Informasi",
      "Programmer",
      "Data Center Spesialis",
    ],
    "Pengembangan Usaha dan Pemasaran": [
      "Manajer Pengembangan Usaha dan Pemasaran",
      "Staf Pengembangan Usaha dan Pemasaran",
    ],
    Investasi: ["Manajer Investasi", "Staf Investasi"],
    "Perencanaan Korporat dan Perijinan": [
      "Kepala Divisi Perencanaan Korporat dan Perijinan",
    ],
    "Perencanaan Korporat dan Portofolio": [
      "Manajer Perencanaan Korporat dan Portofolio",
      "Staf Perencanaan Korporat dan Portofolio",
    ],
    "Pengadaan dan Perijinan": [
      "Manajer Pengadaan dan Perijinan",
      "Staf Pengadaan dan Perijinan",
    ],
  },
  Keuangan: {
    "SDM, Umum dan Hukum": ["Kepala Divisi SDM, Umum dan Hukum"],
    "Hukum dan Manajemen Risiko": [
      "Manajer Hukum dan Manajemen Risiko",
      "Staf Manajer Hukum dan Manajemen Risiko",
    ],
    "SDM dan Umum": ["Manajer SDM dan Umum", "Staf SDM dan Umum"],
    "Jasa Penyedia Tenaga Kerja": [
      "Manajer Jasa Penyedia Tenaga Kerja",
      "Staf Jasa Penyedia Tenaga Kerja",
    ],
    Keuangan: ["Kepala Divisi Keuangan"],
    "Anggaran dan Keuangan": [
      "Manajer Anggaran dan Keuangan",
      "Staf Anggaran dan Keuangan",
    ],
    "Akuntansi dan Pajak": ["Manajer Akuntansi dan Pajak"],
    Akuntansi: ["Asisten Manajer Akuntansi", "Staf Akuntansi"],
    "Pajak, Asuransi dan Pendanaan": [
      "Asisten Manajer Pajak, Asuransi dan Pendanaan",
      "Staf Pajak, Asuransi dan Pendanaan",
    ],
  },
  "Operasional dan Teknik": {
    "Pengendalian Proyek Konstruksi": [
      "Kepala Divisi Pengendalian Proyek Konstruksi",
      "Supervisor Pengendalian Proyek Konstruksi",
      "Staf Pengendalian Proyek Konstruksi",
    ],
    "Perencanaan Konstruksi": [
      "Manajer Perencanaan Konstruksi",
      "Staf Perencanaan Konstruksi",
    ],
    "Pengendalian Proyek Konstruksi dan Konstruksi": [
      "Manajer Pengendalian Proyek Konstruksi dan Konstruksi",
    ],
    "Administrasi Proyek Konstruksi": [
      "Asisten Manajer Administrasi Proyek Konstruksi",
      "Staf Administrasi Proyek Konstruksi",
    ],
    "Pengelolaan dan Pemeliharaan Gedung": [
      "Kepala Divisi Pengelolaan dan Pemeliharaan Gedung",
    ],
    "Jasa Pengelolaan dan Pemeliharaan Gedung": [
      "Manajer Jasa Pengelolaan dan Pemeliharaan Gedung",
      "Staf Jasa Pengelolaan dan Pemeliharaan Gedung",
    ],
    "Jasa Pengelolaan Gedung": [
      "Asisten Manajer Jasa Pengelolaan Gedung",
      "Staf Jasa Pengelolaan Gedung",
    ],
    "Jasa Pemeliharaan Gedung": [
      "Asisten Manajer Jasa Pemeliharaan Gedung",
      "Staf Jasa Pemeliharaan Gedung",
    ],
  },
  Vendor: {
    Vendor: ["Vendor"],
  },
  MBPST: { MBPST: ["MBPST"] },
  PJTKRBG: { PJTKRBG: ["PJTKRBG"] },
  PJTKBTM: { PJTKBTM: ["PJTKBTM"] },
  PJTKPTN: { PJTKPTN: ["PJTKPTN"] },
  PJTKBPP: { PJTKBPP: ["PJTKBPP"] },
  PJTKMKS: { PJTKMKS: ["PJTKMKS"] },
  PJTKLSM: { PJTKLSM: ["PJTKLSM"] },
  PJTKPRT: { PJTKPRT: ["PJTKPRT"] },
  PJTKNTB: { PJTKNTB: ["PJTKNTB"] },
  PJTKMRK: { PJTKMRK: ["PJTKMRK"] },
  PJTKBLW: { PJTKBLW: ["PJTKBLW"] },
  PJTKPDG: { PJTKPDG: ["PJTKPDG"] },
  MBWIJAYA: { MBWIJAYA: ["MBWIJAYA"] },
  MBIP: { MBIP: ["MBIP"] },
  MBUIPJBB: { MBUIPJBB: ["MBUIPJBB"] },
};

interface AdvancedSearchDialogProps {
  open: boolean;
  onClose: () => void;
  onSearchResults: (results: Employee[]) => void;
}

interface OfficeOption {
  officeId: string;
  officeName: string;
}

interface VendorOption {
  vendorId: string;
  vendorName: string;
}

const EmployeeListPage: React.FC = () => {
  const [selectedRows, setSelectedRows] = useState<number[]>([]);
  const [showSearch, setShowSearch] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [rows, setRows] = useState<any[]>([]);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [openAddEmployeeDialog, setOpenAddEmployeeDialog] = useState(false);
  const [openEditEmployeeDialog, setOpenEditEmployeeDialog] = useState(false);
  const [openFilterDialog, setOpenFilterDialog] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState("");
  const [limit, setLimit] = useState(10); // Jumlah item per halaman
  const [rowsPerPage, setRowsPerPage] = useState(10); // Jumlah item per halaman
  const [totalItems, setTotalItems] = useState(0); // Total semua data
  const [currentPage, setCurrentPage] = useState(1); // Halaman aktif
  const [totalPages, setTotalPages] = useState(1); // Total halaman

  const [selectedDirectorateAdd, setSelectedDirectorateAdd] = useState("");
  const [selectedDivisionAdd, setSelectedDivisionAdd] = useState("");
  const [selectedJobTitleAdd, setSelectedJobTitleAdd] = useState("");

  const [selectedDirectorateEdit, setSelectedDirectorateEdit] = useState("");
  const [selectedDivisionEdit, setSelectedDivisionEdit] = useState("");
  const [selectedJobTitleEdit, setSelectedJobTitleEdit] = useState("");

  const [officeFilterOptions, setOfficeFilterOptions] = useState<
    OfficeOption[]
  >([]);
  const [vendorFilterOptions, setVendorFilterOptions] = useState<
    VendorOption[]
  >([]);

  // Fungsi untuk mengambil data karyawan

  // Employee Data Table ========================================================================
  // Fungsi untuk mengambil data karyawan
  const reloadEmployee = async () => {
    setIsLoading(true);
    setError(""); // Reset error sebelum memuat ulang data
    try {
      const result = await getEmployees({
        ...filterParams,
        limit: rowsPerPage,
        offset,
        orderBy: sortConfig.orderBy,
        order: sortConfig.order,
      });

      // Format position data sebelum disimpan ke state
      const formattedData = result.data.map((employee) => ({
        ...employee,
        position: formatPositionDisplay(employee.position),
      }));

      setRows(formattedData);
      setTotalItems(result.total);
      setTotalPages(result.pagination.totalPages);
    } catch (err: any) {
      setError(err.message);
    } finally {
      setIsLoading(false);
    }
  };

  const offset = (currentPage - 1) * rowsPerPage;

  const [filterParams, setFilterParams] = useState<{
    id?: string;
    name?: string;
    nik?: string;
    jobTitle?: string;
    division?: string;
    office?: string;
    status?: string;
    employeeType?: string;
    keyword?: string;
  }>({});

  // Sort
  const [sortConfig, setSortConfig] = useState<{
    orderBy: string;
    order: "asc" | "desc";
  }>({
    orderBy: "createdAt",
    order: "desc",
  });

  const handleSort = (column: string) => {
    setSortConfig((prev) => {
      if (prev.orderBy === column) {
        return {
          orderBy: column,
          order: prev.order === "asc" ? "desc" : "asc",
        };
      } else {
        return {
          orderBy: column,
          order: "asc",
        };
      }
    });
    setCurrentPage(1); // reset ke halaman 1 saat sort berubah
  };

  // Fungsi untuk menangani pemilihan checkbox baris
  const handleSelectRow = (id: number) => {
    setSelectedRows((prev) =>
      prev.includes(id) ? prev.filter((rowId) => rowId !== id) : [...prev, id]
    );
  };

  const CustomTextField = styled(TextField)({
    "& .MuiInputBase-input": {
      backgroundColor: "#f5f5f5",
      borderRadius: 4,
      padding: "8px 12px",
    },
  });

  const handleDeleteEmployee = async (confirm: boolean = true) => {
    const confirmDelete = await Swal.fire({
      title: "Apakah Anda yakin?",
      text: "Anda tidak dapat mengembalikan data yang dihapus!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Ya, hapus!",
      cancelButtonText: "Batal",
    });

    if (!confirmDelete.isConfirmed) return;

    try {
      const rowsToDelete = [...selectedRows];
      const employeesToDelete = rows.filter((row) =>
        rowsToDelete.includes(row.id)
      );

      for (const employee of employeesToDelete) {
        if (!employee.email) {
          // Fallback to get details if email isn't in the row data
          const employeeDetails = await getEmployeeById(employee.id);
          await deleteEmployeeByEmail(employeeDetails.email);
        } else {
          await deleteEmployeeByEmail(employee.email);
        }
      }

      Swal.fire({
        icon: "success",
        title: "Karyawan berhasil dihapus",
        confirmButtonColor: "#0F62FE",
      });

      setSelectedRows([]);
      setRows((prevRows) =>
        prevRows.filter((row) => !rowsToDelete.includes(row.id))
      );
      setOpenDeleteDialog(false);
    } catch (error: any) {
      let errorMessage = "Terjadi kesalahan";

      // Jika error memiliki response data dari backend
      if (error.response?.data) {
        const backendError = error.response.data;
        errorMessage = `${backendError.error}`;

        // Tambahkan detail error jika ada
        if (backendError.details) {
          errorMessage += `: ${backendError.details}`;
        }
      } else if (error.message) {
        errorMessage = error.message;
      }

      Swal.fire({
        icon: "error",
        title: "Gagal menghapus karyawan",
        text: errorMessage,
      });
    }
  };

  // 🔄 Pastikan selectedRows update setelah rows berubah
  useEffect(() => {
    setSelectedRows([]);
  }, [rows]);

  const [filters, setFilters] = useState([{ field: "name", value: "" }]);
  const [employees, setEmployees] = useState<Employee[]>([]);

  // Daftar pilihan filter yang tersedia
  const availableFilters = [
    { value: "name", label: "Employee Name" },
    { value: "nik", label: "Employee Number" },
    { value: "jobTitle", label: "Employee Job Title" },
    { value: "division", label: "Employee Division" },
    { value: "office", label: "Employee Office Location" },
    { value: "company", label: "Employee Vendor" },
    { value: "status", label: "Employee Status" },
    { value: "employeeType", label: "Employee Type" },
  ];

  // FILTER

  const handleFilterChange = (index: number, key: string, value: string) => {
    const newFilters = [...filters];
    newFilters[index][key] = value;
    setFilters(newFilters);
  };

  const handleAddFilter = () => {
    setFilters([...filters, { field: "", value: "" }]);
  };

  const handleRemoveFilter = (index: number) => {
    setFilters(filters.filter((_, i) => i !== index));
  };

  const handleApplyFilters = async () => {
    setIsLoading(true);
    try {
      const searchParams: employeeSearchParams = {};

      filters.forEach((filter) => {
        if (filter.value.trim() !== "") {
          // Handle special cases for office and company
          if (filter.field === "office") {
            const selectedOffice = officeFilterOptions.find(
              (opt) => opt.officeName === filter.value
            );
            if (selectedOffice) {
              searchParams.office = selectedOffice.officeId;
            }
          } else if (filter.field === "company") {
            const selectedVendor = vendorFilterOptions.find(
              (opt) => opt.vendorName === filter.value
            );
            if (selectedVendor) {
              searchParams.company = selectedVendor.vendorId;
            }
          } else {
            searchParams[filter.field] = filter.value;
          }
        }
      });

      setFilterParams(searchParams);
      setOpenFilterDialog(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      Swal.fire({
        icon: "error",
        title: "Gagal mengambil data",
        text: error.response?.data?.message || "Terjadi kesalahan",
      });
      handleCloseFilter();
    } finally {
      setIsLoading(false);
    }
  };

  // ✅ Tambahkan fungsi ini
  const handleSearchResults = (results) => {
    setRows(results); // Update rows agar sesuai dengan format tabel
    setOpenFilterDialog(false); // Tutup dialog setelah apply filter
  };

  const handleCloseFilter = () => {
    setOpenFilterDialog(false);
  };

  const handleResetFilters = () => {
    setFilters([{ field: "name", value: "" }]); // Reset ke kondisi awal dengan satu filter kosong
  };

  //======================= Search ===================================
  const handleSearch = async () => {
    setIsLoading(true);
    setError("");

    try {
      setFilterParams({
        keyword: searchQuery,
      });
    } catch (err: any) {
      let errorMessage = "Terjadi kesalahan saat melakukan pencarian";

      // Jika error memiliki response data dari backend
      if (err.response?.data) {
        const backendError = err.response.data;
        errorMessage = backendError.error || errorMessage;

        // Tambahkan detail error jika ada
        if (backendError.details) {
          errorMessage += `: ${backendError.details}`;
        }
      } else if (err.message) {
        errorMessage = err.message;
      }

      // Set error state untuk ditampilkan di UI
      setError(errorMessage);

      // Anda juga bisa menampilkan alert/Swal jika diperlukan
      Swal.fire({
        icon: "error",
        title: "Gagal melakukan pencarian",
        text: errorMessage,
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleExport = async () => {
    try {
      // Tampilkan loading
      Swal.fire({
        title: "Preparing Export...",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      // Pastikan data vendors dan offices sudah terload
      // Jika belum, fetch terlebih dahulu
      let vendorsData = vendors;
      let officesData = offices;

      if (vendors.length === 0) {
        vendorsData = await fetchVendors();
      }

      if (offices.length === 0) {
        officesData = await fetchOffices();
      }

      // Ambil semua data karyawan dengan filter yang sama
      const allEmployees = await getEmployees({
        ...filterParams,
        limit: 10000, // Ambil semua data
        offset: 0,
        orderBy: sortConfig.orderBy,
        order: sortConfig.order,
      });

      // Fungsi helper untuk format data
      const formatDate = (date: Date | null): string => {
        return date ? new Date(date).toLocaleDateString("id-ID") : "-";
      };

      const formatNumber = (value) => {
        if (value === null || value === undefined) return "";
        const num = Number(value);
        if (isNaN(num)) return value;
        return num.toString().replace(/,/g, "."); // Replace comma with dot
      };

      const formatCurrency = (value: number | null) => {
        if (value === null || isNaN(value)) return 'Rp 0,00';

        return new Intl.NumberFormat('id-ID', {
          style: 'currency',
          currency: 'IDR',
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }).format(value);
      };

      const formatTimestampz = (
        timestamp: string | Date | null,
        withTime: boolean = true
      ): string => {
        if (!timestamp) return "-";
        const date = new Date(timestamp);
        if (isNaN(date.getTime())) return "Invalid Date";

        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();
        const datePart = `${day}/${month}/${year}`;

        if (!withTime) return datePart;

        const hours = String(date.getHours()).padStart(2, "0");
        const minutes = String(date.getMinutes()).padStart(2, "0");
        const seconds = String(date.getSeconds()).padStart(2, "0");
        const timePart = `${hours}:${minutes}:${seconds}`;

        return `${datePart} ${timePart}`;
      };

      // Format data untuk export
      const exportData = allEmployees.data.map((employee) => {
        // Cari nama vendor
        const vendor = vendorsData.find((v) => v.vendorId === employee.company);
        const vendorName = vendor ? vendor.vendorName : "-";

        // Cari nama office
        const office = officesData.find((o) => o.officeId === employee.office);
        const officeName = office ? office.officeName : "-";

        return {
          // Identitas Dasar
          NIK: employee.nik || "-",
          "Nama Karyawan": employee.name || "-",
          "Jenis Kelamin": employee.gender || "-",
          "Tanggal Lahir": formatDate(employee.dateOfBirth),
          "Kota Lahir": employee.cityOfBirth || "-",
          Agama: employee.religion || "-",
          "Status Pernikahan": employee.maritalStatus || "-",
          "Jumlah Anak":
            employee.totalAnak !== null ? employee.totalAnak.toString() : "-",

          // Kontak
          Alamat: employee.address || "-",
          Telepon: employee.phone !== null ? employee.phone.toString() : "-",
          Email: employee.email || "-",

          // Pekerjaan
          Direktorat: employee.directorate || "-",
          Divisi: employee.division || "-",
          Position: employee.position || "-",
          "Job Title": employee.jobTitle || "-",
          "Status Karyawan": employee.status || "-",
          "Tipe Karyawan": employee.employeeType || "-",
          Kantor: officeName, // Menggunakan nama office
          "Perusahaan Vendor": vendorName, // Menggunakan nama vendor
          "Tanggal Bergabung": formatDate(employee.dateOfJoining),
          "Tanggal Berakhir": formatDate(employee.expiredDate),

          // Data Finansial
          NPWP: employee.taxIdNumber || "-",
          "Gaji Pokok": formatNumber(employee.salary),
          "Koefisien Gaji":
            employee.salaryCoefficient !== null
              ? employee.salaryCoefficient.toFixed(2)
              : "-",
          "Delta Gaji": formatNumber(employee.salaryDelta),
          "Tunjangan Kontribusi": formatNumber(
            employee.contributionAllowance
          ),
          "Tunjangan Layanan": formatNumber(employee.serviceAllowance),
          "Tunjangan Lainnya": formatNumber(employee.otherAllowance),

          // Rekening Bank
          "Nama Bank": employee.bankName || "-",
          "Nomor Rekening": employee.bankNumber || "-",
          "Nama Pemilik Rekening": employee.bankAccountName || "-",

          // Lainnya
          Catatan: employee.notes || "-",
          "Tanggal Dibuat": formatTimestampz(employee.createdAt) || "-",
          "Tanggal Diupdate": formatTimestampz(employee.updateAt) || "-",
        };
      });

      // Buat worksheet
      const ws = XLSX.utils.json_to_sheet(exportData);

      // Buat workbook
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Employees");

      // Generate file Excel
      const date = new Date().toISOString().slice(0, 10);
      XLSX.writeFile(wb, `Employees_${date}.xlsx`);

      // Tutup loading
      Swal.close();
    } catch (error) {
      console.error("Export failed:", error);
      Swal.fire({
        icon: "error",
        title: "Export Gagal",
        text: error.message || "Gagal export data karyawan",
      });
    }
  };

  // Fungsi untuk mengambil data yang akan diexport
  const getExportData = async () => {
    const allEmployees = await getEmployees({
      ...filterParams,
      limit: 10000, // Ambil semua data
      offset: 0,
      orderBy: sortConfig.orderBy,
      order: sortConfig.order,
    });

    // Formatting helper functions
    const formatDate = (date: Date | null): string => {
      return date ? new Date(date).toLocaleDateString("id-ID") : "-";
    };

    const formatNumber = (value) => {
      if (value === null || value === undefined) return "";
      const num = Number(value);
      if (isNaN(num)) return value;
      return num.toString().replace(/,/g, "."); // Replace comma with dot
    };

    const formatTimestampz = (
      timestamp: string | Date | null,
      withTime: boolean = true
    ): string => {
      if (!timestamp) return "-";

      const date = new Date(timestamp);

      if (isNaN(date.getTime())) return "Invalid Date";

      // Format tanggal: DD/MM/YYYY
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();
      const datePart = `${day}/${month}/${year}`;

      if (!withTime) return datePart;

      // Format waktu: HH:MM:SS
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      const seconds = String(date.getSeconds()).padStart(2, "0");
      const timePart = `${hours}:${minutes}:${seconds}`;

      return `${datePart} ${timePart}`;
    };

    return allEmployees.data.map((employee) => ({
      // Identitas Dasar
      NIK: employee.nik || "-",
      "Nama Karyawan": employee.name || "-",
      "Jenis Kelamin": employee.gender || "-",
      "Tanggal Lahir": formatDate(employee.dateOfBirth),
      "Kota Lahir": employee.cityOfBirth || "-",
      Agama: employee.religion || "-",
      "Status Pernikahan": employee.maritalStatus || "-",
      "Jumlah Anak":
        employee.totalAnak !== null ? employee.totalAnak.toString() : "-",

      // Kontak
      Alamat: employee.address || "-",
      Telepon: employee.phone !== null ? employee.phone.toString() : "-",
      Email: employee.email || "-",

      // Pekerjaan
      Perusahaan: employee.company || "-",
      Direktorat: employee.directorate || "-",
      Divisi: employee.division || "-",
      Position: employee.position || "-",
      "Job Title": employee.jobTitle || "-",
      "Status Karyawan": employee.status || "-",
      "Tipe Karyawan": employee.employeeType || "-",
      Kantor: employee.office || "-",
      "Tanggal Bergabung": formatDate(employee.dateOfJoining),
      "Tanggal Berakhir": formatDate(employee.expiredDate),

      // Data Finansial
      NPWP: employee.taxIdNumber || "-",
      "Gaji Pokok": formatNumber(employee.salary),
      "Koefisien Gaji":
        employee.salaryCoefficient !== null
          ? employee.salaryCoefficient.toFixed(2)
          : "-",
      "Delta Gaji": formatNumber(employee.salaryDelta),
      "Tunjangan Kontribusi": formatNumber(employee.contributionAllowance),
      "Tunjangan Layanan": formatNumber(employee.serviceAllowance),
      "Tunjangan Lainnya": formatNumber(employee.otherAllowance),

      // Rekening Bank
      "Nama Bank": employee.bankName || "-",
      "Nomor Rekening": employee.bankNumber || "-",
      "Nama Pemilik Rekening": employee.bankAccountName || "-",

      // Lainnya
      Catatan: employee.notes || "-",
      "Tanggal Dibuat": formatTimestampz(employee.createdAt) || "-",
      "Tanggal Diupdate": formatTimestampz(employee.updateAt) || "-",
    }));
  };

  // Fungsi untuk memformat data karyawan untuk export
  const formatEmployeeForExport = (employee) => ({
    "Employee Name": employee.name,
    "Employee Number": employee.nik,
    Position: employee.position,
    Division: employee.division,
    Office: employee.office,
    Status: employee.status,
    "Employee Type": employee.employeeType,
    // ... tambahkan field lainnya sesuai kebutuhan
  });

  // add employee data ========================================================================
  const [employeeDataAdd, setEmployeeDataAdd] = useState<{
    name: string;
    dateOfBirth: Date | null;
    cityOfBirth: string;
    religion: string;
    address: string;
    phone: number | null;
    email: string;
    gender: string;
    maritalStatus: string;
    nik: string;
    position: any[];
    totalAnak: number | null;
    directorate: string;
    division: string;
    jobTitle: string;
    status: string;
    employeeType: string;
    office: string;
    company: string;
    dateOfJoining: Date | null;
    expiredDate: Date | null;
    taxIdNumber: string;
    salary: number | null;
    salaryCoefficient: number | null;
    salaryDelta: number | null;
    contributionAllowance: number | null;
    serviceAllowance: number | null;
    coachingAllowance: number | null;
    transportAllowance: number | null;
    housingAllowance: number | null;
    telecommunicationAllowance: number | null;
    positionAllowance: number | null;
    mobilePhoneAllowance: number | null;
    overtimeAllowance: number | null;
    naturaAllowance: number | null;
    otherAllowance: number | null;
    bankName: string;
    bankNumber: string;
    bankAccountName: string;
    notes: string;
    bpjsKesehatan: number | null;
    bpjsTK: number | null;
    pTKPCategory: PTKPCategory;
    categoryTER: CategoryTER;
    pph21: number | null;
    grossSalary: number | null;
    nettSalary: number | null;
    file: File | null;
  }>({
    name: "",
    dateOfBirth: null,
    cityOfBirth: "",
    religion: "",
    address: "",
    phone: null,
    email: "",
    gender: "",
    maritalStatus: "",
    nik: "",
    position: [],
    totalAnak: 0,
    directorate: "",
    division: "",
    jobTitle: "",
    status: "",
    employeeType: "",
    office: "",
    company: "",
    dateOfJoining: null,
    expiredDate: null,
    taxIdNumber: "",
    salary: null,
    salaryCoefficient: null,
    salaryDelta: null,
    contributionAllowance: null,
    serviceAllowance: null,
    coachingAllowance: null,
    transportAllowance: null,
    housingAllowance: null,
    telecommunicationAllowance: null,
    positionAllowance: null,
    mobilePhoneAllowance: null,
    overtimeAllowance: null,
    naturaAllowance: null,
    otherAllowance: null,
    bankName: "",
    bankNumber: "",
    bankAccountName: "",
    notes: "",
    bpjsKesehatan: null,
    bpjsTK: null,
    pTKPCategory: "TK/0",
    categoryTER: "TER A",
    pph21: null,
    grossSalary: null,
    nettSalary: null,
    file: null,
  });

  const handleInputChangeAdd = (e) => {
    const { name, value } = e.target;

    // // Special handling for directorate change
    // if (name === "directorate") {
    //   setEmployeeDataAdd((prevState) => ({
    //     ...prevState,
    //     [name]: value,
    //     division: "", // Reset division
    //     jobTitle: "", // Reset jobTitle
    //   }));
    //   return;
    // }

    // // Special handling for division change
    // if (name === "division") {
    //   setEmployeeDataAdd((prevState) => ({
    //     ...prevState,
    //     [name]: value,
    //     jobTitle: "", // Reset jobTitle
    //   }));
    //   return;
    // }

    // Special handling for salary coefficient (decimal number field)
    if (name === "salaryCoefficient") {
      if (value === null || /^\d*\.?\d*$/.test(value)) {
        setEmployeeDataAdd((prevState) => ({
          ...prevState,
          [name]: value,
        }));
      }
      return;
    }

    // Handle marital status change separately
    if (name === "maritalStatus") {
      setEmployeeDataAdd((prevState) => ({
        ...prevState,
        [name]: value,
        ...(value !== "Married" ? { totalAnak: 0 } : {}),
      }));
      return;
    }

    // Default handling for all other fields
    setEmployeeDataAdd((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const [errorsAdd, setErrorsAdd] = useState({
    name: false,
    dateOfBirth: false,
    cityOfBirth: false,
    religion: false,
    address: false,
    phone: false,
    email: false,
    gender: false,
    maritalStatus: false,
    employeeID: false,
    position: false,
    directorate: false,
    division: false,
    jobTitle: false,
    employeeStatus: false,
    employeeType: false,
    office: false,
    dateOfJoining: false,
    taxIdNumber: false,
    salary: false,
    // salaryCoefficient: false,
    // salaryDelta: false,
    // contributionAllowance: false,
    // serviceAllowance: false,
    // otherAllowance: false,
    bankName: false,
    bankNumber: false,
    bankAccountName: false,
  });

  const resetAddForm = () => {
    setEmployeeDataAdd({
      name: "",
      dateOfBirth: null,
      cityOfBirth: "",
      religion: "",
      address: "",
      phone: null,
      email: "",
      gender: "",
      maritalStatus: "",
      nik: "",
      position: [],
      totalAnak: 0,
      directorate: "",
      division: "",
      jobTitle: "",
      status: "",
      employeeType: "",
      office: "",
      company: "",
      dateOfJoining: null,
      expiredDate: null,
      taxIdNumber: "",
      salary: null,
      salaryCoefficient: null,
      salaryDelta: null,
      contributionAllowance: null,
      serviceAllowance: null,
      coachingAllowance: null,
      transportAllowance: null,
      housingAllowance: null,
      telecommunicationAllowance: null,
      positionAllowance: null,
      mobilePhoneAllowance: null,
      overtimeAllowance: null,
      naturaAllowance: null,
      otherAllowance: null,
      bankName: "",
      bankNumber: "",
      bankAccountName: "",
      notes: "",
      bpjsKesehatan: null,
      bpjsTK: null,
      pTKPCategory: "TK/0",
      pph21: null,
      categoryTER: getCategoryTERFromPTKP("TK/0"),
      grossSalary: null,
      nettSalary: null,
      file: null,
    });
    setPreviewUrl("");
  };

  const handleOpenAddDialog = () => {
    resetAddForm();
    setOpenAddEmployeeDialog(true);
  };

  const handleDirectorateChangeAdd = (event: any) => {
    setSelectedDirectorateAdd(event.target.value);
    setSelectedDivisionAdd("");
    setSelectedJobTitleAdd("");

    setEmployeeDataAdd({
      ...employeeDataAdd,
      directorate: event.target.value,
      division: "",
      jobTitle: "",
    });
  };

  const handleDivisionChangeAdd = (event: any) => {
    setSelectedDivisionAdd(event.target.value);
    setSelectedJobTitleAdd("");

    setEmployeeDataAdd({
      ...employeeDataAdd,
      division: event.target.value,
      jobTitle: "",
    });
  };

  const handleJobTitleChangeAdd = (event: any) => {
    setSelectedJobTitleAdd(event.target.value);

    setEmployeeDataAdd({ ...employeeDataAdd, jobTitle: event.target.value });
  };

  const divisionsAdd = selectedDirectorateAdd
    ? Object.keys(positionData[selectedDirectorateAdd])
    : [];
  const jobTitlesAdd =
    selectedDirectorateAdd && selectedDivisionAdd
      ? positionData[selectedDirectorateAdd][selectedDivisionAdd]
      : [];

  const [roles, setRoles] = useState<Role[]>([]);
  const [loadingRoles, setLoadingRoles] = useState(false);
  const [vendors, setVendors] = useState<Vendor[]>([]);
  const [offices, setOffices] = useState<Office[]>([]);
  const [loadingVendors, setLoadingVendors] = useState(false);
  const [loadingOffices, setLoadingOffices] = useState(false);
  // In your component state:
  const [availableRoles, setAvailableRoles] = useState<Role[]>([]);
  const [selectedRoles, setSelectedRoles] = useState<SelectedRole[]>([]);
  const [roleSearch, setRoleSearch] = React.useState("");

  // Add these handler functions
  const handleRoleSelection = (roleId: string) => {
    setSelectedRoles((prevRoles) =>
      prevRoles.map((role) =>
        role.id === roleId ? { ...role, selected: !role.selected } : role
      )
    );
  };

  const handleAddRole = () => {
    setSelectedRoles((prevRoles) => [
      ...prevRoles,
      { id: Date.now().toString(), name: "", selected: true },
    ]);
  };

  const handleRemoveRole = (roleId: string) => {
    setSelectedRoles((prevRoles) =>
      prevRoles.filter((role) => role.id !== roleId)
    );
  };

  const handleRoleNameChange = (roleId: string, newName: string) => {
    setSelectedRoles((prevRoles) =>
      prevRoles.map((role) =>
        role.id === roleId ? { ...role, name: newName } : role
      )
    );
  };

  // Handle adding a new role
  const handleAddRoles = () => {
    if (!newRole) return;

    // Check if role already exists
    if (!employeeDataAdd.position.includes(newRole)) {
      setEmployeeDataAdd((prev) => ({
        ...prev,
        position: [...prev.position, newRole],
      }));
    }

    setNewRole(""); // Reset selection
  };

  // Handle removing a role
  const handleRemoveRoles = (index: number) => {
    setEmployeeDataAdd((prev) => ({
      ...prev,
      position: prev.position.filter((_, i) => i !== index),
    }));
  };

  const handleFileChangeAdd = (event) => {
    setEmployeeDataAdd((prevData) => ({
      ...prevData,
      file: event.target.files[0],
    }));
  };

  const validateFormAdd = () => {
    let newErrors = {
      name: !employeeDataAdd.name,
      dateOfBirth: !employeeDataAdd.dateOfBirth,
      cityOfBirth: !employeeDataAdd.cityOfBirth,
      religion: !employeeDataAdd.religion,
      address: !employeeDataAdd.address,
      phone: !employeeDataAdd.phone,
      email: !employeeDataAdd.email,
      gender: !employeeDataAdd.gender,
      //maritalStatus: !employeeDataAdd.maritalStatus,
      employeeID: !employeeDataAdd.nik,
      position: !employeeDataAdd.position,
      directorate: !employeeDataAdd.directorate,
      division: !employeeDataAdd.division,
      jobTitle: !employeeDataAdd.jobTitle,
      employeeStatus: !employeeDataAdd.status,
      employeeType: !employeeDataAdd.employeeType,
      office: !employeeDataAdd.office,
      dateOfJoining: !employeeDataAdd.dateOfJoining,
      taxIdNumber: !employeeDataAdd.taxIdNumber,
      salary: !employeeDataAdd.salary,
      // salaryCoefficient: !employeeDataAdd.salaryCoefficient,
      // salaryDelta: !employeeDataAdd.salaryDelta,
      // contributionAllowance: !employeeDataAdd.contributionAllowance,
      // serviceAllowance: !employeeDataAdd.serviceAllowance,
      // otherAllowance: !employeeDataAdd.otherAllowance,
      bankName: !employeeDataAdd.bankName,
      bankNumber: !employeeDataAdd.bankNumber,
      bankAccountName: !employeeDataAdd.bankAccountName,
    };
    setErrorsAdd(newErrors);
    return !Object.values(newErrors).includes(true);
  };

  const showPopupMandatoryError = () => {
    Swal.fire({
      icon: "error",
      title: "Data Belum Lengkap",
      text: "Lengkapi data yang wajib diisi.",
    });
  };

  const handleSaveAdd = async () => {
    try {
      if (!validateFormAdd()) {
        showPopupMandatoryError();
        return;
      }

      if (!employeeDataAdd.position || employeeDataAdd.position.length === 0) {
        Swal.fire({
          icon: "warning",
          title: "Role Dibutuhkan",
          text: "Wajib pilih minimal 1 role untuk karyawan",
          confirmButtonColor: "#0F62FE",
        });
        return;
      }

      const selectedRoles = employeeDataAdd.position.map((roleId) => {
        const role = roles.find((r) => r.id === roleId);
        return role ? role.name : roleId;
      });

      const employeeDataWithRoles = {
        ...employeeDataAdd,
        position: selectedRoles,
        username: employeeDataAdd.email.split("@")[0],
      };

      const result = await createEmployeeWithAccount(
        employeeDataWithRoles,
        employeeDataAdd.file || undefined
      );

      Swal.fire({
        icon: "success",
        title: "Karyawan berhasil dibuat",
        html: `
          <div>
            <p>Data karyawan, user account, dan role assignment sukses dibuat</p>
            <p>Default password: <strong>qwerty123!</strong></p>
            <p><em>User diharuskan mengubah password pada pertama kali login</em></p>
          </div>
        `,
        confirmButtonColor: "#0F62FE",
      });

      setOpenAddEmployeeDialog(false);
      reloadEmployee();
    } catch (error: any) {
      let errorTitle = "Gagal membuat karyawan";
      let errorDetails = "";

      // Handle backend error response
      if (error.response?.data) {
        const backendError = error.response.data;

        // Debug log untuk melihat struktur error
        console.log("Backend Error Structure:", {
          error: backendError.error,
          details: backendError.details,
          errors: backendError.errors,
          duplicates: backendError.duplicates,
        });

        // Main error message
        errorTitle = backendError.error || errorTitle;

        // Handle email validation specifically - PERBAIKAN UTAMA DI SINI
        if (backendError.details) {
          if (
            /validation isEmail on email failed/i.test(backendError.details)
          ) {
            errorTitle = "Format Email Tidak Valid";
            errorDetails =
              "Harap masukkan alamat email yang benar (contoh: nama@perusahaan.com)";
          } else {
            // Hanya gunakan details jika bukan error email
            errorDetails = backendError.details;
          }
        }

        // Handle validation errors
        if (backendError.errors) {
          const validationMessages = Object.values(backendError.errors)
            .map((err: any) => {
              // Custom mapping untuk error email
              if (err.path === "email" && err.validatorKey === "isEmail") {
                return "• Format email tidak valid (contoh: nama@perusahaan.com)";
              }
              return `• ${err.message}`;
            })
            .join("\n");

          // Gabungkan dengan error details jika ada
          errorDetails = errorDetails
            ? `${errorDetails}\n${validationMessages}`
            : validationMessages;
        }

        // Handle duplicate fields
        if (backendError.duplicates) {
          const duplicateMessages = backendError.duplicates
            .map((dup: any) => `• ${dup.field}: ${dup.value} sudah terdaftar`)
            .join("\n");

          errorDetails = errorDetails
            ? `${errorDetails}\n${duplicateMessages}`
            : duplicateMessages;
        }
      }
      // Handle network or other errors
      else {
        errorDetails =
          error.message || "Terjadi kesalahan yang tidak diketahui";
      }

      // Show error in Swal
      Swal.fire({
        icon: "error",
        title: errorTitle,
        html: `
          <div style="text-align: left;">
            <p style="font-weight: bold; margin-bottom: 8px;">${errorTitle}</p>
            ${errorDetails
            ? `<div style="
                    color: #d32f2f;
                    background: #ffebee;
                    padding: 10px;
                    border-radius: 4px;
                    font-size: 0.9em;
                    border-left: 3px solid #d32f2f;
                  ">
                    ${errorDetails.replace(/\n/g, "<br>")}
                  </div>`
            : ""
          }
          </div>
        `,
        confirmButtonColor: "#0F62FE",
      });
    }
  };

  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [previewUrl, setPreviewUrl] = useState<string>("");
  const [roleOptions, setRoleOptions] = useState<RoleOption[]>([]);
  const [newRole, setNewRole] = useState<string>("");

  // Fungsi untuk menghapus permission
  const handleRemovePosition = (index) => {
    const updatedPosition = [...employeeDataAdd.position];
    updatedPosition.splice(index, 1);
    setEmployeeDataAdd({
      ...employeeDataAdd,
      position: updatedPosition,
    });
  };

  // Fungsi untuk menentukan categoryTER berdasarkan PTKP
  const getCategoryTERFromPTKP = (ptkpCategory: PTKPCategory): CategoryTER => {
    switch (ptkpCategory) {
      case 'TK/0': // Tidak Kawin dan Tidak Ada Tanggungan
      case 'TK/1': // Tidak Kawin dengan Satu Tanggungan  
      case 'K/0':  // Kawin dan Tidak Ada Tanggungan
        return 'TER A';
      case 'TK/2': // Tidak Kawin dengan Dua Tanggungan
      case 'TK/3': // Tidak Kawin dengan Tiga Tanggungan
      case 'K/1':  // Kawin dengan Satu Tanggungan
      case 'K/2':  // Kawin dengan Dua Tanggungan
        return 'TER B';
      case 'K/3':  // Kawin dengan Tiga Tanggungan
        return 'TER C';
      default:
        return 'TER A'; // Default value
    }
  };

  // Fungsi perhitungan
  const calculateSalariesAdd = (data: any) => {
    const salary = data.salary || 0;
    const coefficient = data.salaryCoefficient || 1;
    const delta = data.salaryDelta || 0;
    const basicSalary = (salary + data.serviceAllowance) || 0;

    // Hitung total allowances
    const totalAllowances =
      (data.contributionAllowance || 0) +
      (data.serviceAllowance || 0) +
      (data.coachingAllowance || 0) +
      (data.transportAllowance || 0) +
      (data.housingAllowance || 0) +
      (data.positionAllowance || 0) +
      (data.telecommunicationAllowance || 0) +
      (data.mobilePhoneAllowance || 0) +
      (data.overtimeAllowance || 0) +
      (data.naturaAllowance || 0) +
      (data.otherAllowance || 0);

    // 5. Hitung Gross Salary
    const grossSalary = parseFloat(((coefficient * salary) + (delta * salary) + totalAllowances).toFixed(2));

    // 1. Hitung BPJS Kesehatan (sesuai regulasi Indonesia)
    // Iuran BPJS Kesehatan 1% dari gaji pokok (4% total, 1% dibayar karyawan, 3% dibayar perusahaan)
    const bpjsKesehatan = (salary + data.serviceAllowance) * 0.01; // 1% ditanggung karyawan

    // 2. Hitung BPJS Ketenagakerjaan (sesuai regulasi Indonesia)
    // - JHT 2% dari gaji pokok (3.7% total, 2% dibayar karyawan, 1.7% dibayar perusahaan)
    // - JKK 0.24%-1.74% (dibayar perusahaan)
    // - JKM 0.30% (dibayar perusahaan)
    // - JP 1% dari gaji pokok (2% total, 1% dibayar karyawan, 1% dibayar perusahaan)
    const bpjsTK = (salary + data.serviceAllowance) * 0.03; // Total 3% ditanggung karyawan (JHT 2% + JP 1%)

    // 6. Hitung Nett Salary
    const nettSalary = parseFloat((salary + data.serviceAllowance).toFixed(2));

    return {
      bpjsKesehatan: parseFloat(bpjsKesehatan.toFixed(2)),
      bpjsTK: parseFloat(bpjsTK.toFixed(2)),
      grossSalary,
      nettSalary
    };
  };

  // Handler untuk perubahan salary
  const handleSalaryChangeAdd = (field: string, value: number | null, setData: Function, currentData: any) => {
    const newData = {
      ...currentData,
      [field]: value !== null ? Number(value) : null
    };

    const calculated = calculateSalariesAdd(newData);

    setData({
      ...newData,
      ...calculated
    });
  };

  const handlePTKPChangeAdd = (e: React.ChangeEvent<{ value: unknown }>) => {
    const value = e.target.value as PTKPCategory;

    setEmployeeDataAdd(prev => {
      const newData = {
        ...prev,
        pTKPCategory: value,
        categoryTER: getCategoryTERFromPTKP(value)
      };

      // Hitung ulang nilai yang tergantung
      const calculated = calculateSalariesAdd(newData);

      return {
        ...newData,
        ...calculated
      };
    });
  };

  const formatCurrency = (value: number | null): string => {
    if (value === null || isNaN(value)) return "Rp 0,00";

    return new Intl.NumberFormat("id-ID", {
      style: "currency",
      currency: "IDR",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(value);
  };

  const handleFileUpload = (file: File) => {
    if (!file) return;

    const validTypes = ["image/png", "image/jpeg", "image/jpg"];
    const maxSize = 5 * 1024 * 1024; // 5MB

    // Validasi format file
    if (!validTypes.includes(file.type)) {
      Swal.fire({
        icon: "error",
        title: "Format file tidak valid",
        text: "Hanya diperbolehkan file PNG, JPG, dan JPEG!",
        confirmButtonColor: "#0F62FE",
        allowOutsideClick: false,
        customClass: {
          popup: "swal-front",
        },
      });
      return;
    }

    // Validasi ukuran file
    if (file.size > maxSize) {
      Swal.fire({
        icon: "warning",
        title: "Ukuran file terlalu besar",
        text: "Ukuran maksimum adalah 5MB",
        confirmButtonColor: "#0F62FE",
        allowOutsideClick: false,
        customClass: {
          popup: "swal-front",
        },
      });
      return;
    }

    // Jika ada preview sebelumnya, hapus untuk mencegah memory leak
    if (previewUrl) {
      URL.revokeObjectURL(previewUrl);
    }

    // Simpan file ke state utama `employeeDataAdd`
    setEmployeeDataAdd((prev) => ({ ...prev, file }));

    // Simpan file ke state dan buat URL preview
    const newPreviewUrl = URL.createObjectURL(file);

    setSelectedFile(file);
    setPreviewUrl(newPreviewUrl);

    console.log("Preview URL:", newPreviewUrl);
    console.log("File disimpan dalam employeeDataAdd:", file);
  };

  const fileInputRef = useRef<HTMLInputElement>(null);
  const editFileInputRef = useRef<HTMLInputElement>(null);

  const handleCloseAdd = () => {
    setOpenAddEmployeeDialog(false);
    resetAddForm(); // Reset form saat ditutup
  };

  //edit employee data ========================================================================
  const [isEditing, setIsEditing] = useState(false);
  const [roleSearchEdit, setRoleSearchEdit] = React.useState("");

  const [selectedEmployeeId, setSelectedEmployeeId] = useState<number | null>(
    null
  );

  const [employeeDataEdit, setEmployeeDataEdit] = useState<{
    id: string;
    name: string;
    dateOfBirth: Date | null;
    cityOfBirth: string;
    religion: string;
    address: string;
    phone: number | null;
    email: string;
    gender: string;
    maritalStatus: string;
    totalAnak: number | null;
    nik: string;
    position: any[];
    directorate: string;
    division: string;
    jobTitle: string;
    status: string;
    employeeType: string;
    office: string;
    company: string; // <-- Jadikan opsional
    dateOfJoining: Date | null;
    expiredDate: Date | null;
    taxIdNumber: string;
    salary: number | null;
    salaryCoefficient: number | null;
    salaryDelta: number | null;
    contributionAllowance: number | null;
    serviceAllowance: number | null;
    coachingAllowance: number | null;
    transportAllowance: number | null;
    housingAllowance: number | null;
    telecommunicationAllowance: number | null;
    positionAllowance: number | null;
    mobilePhoneAllowance: number | null;
    overtimeAllowance: number | null;
    naturaAllowance: number | null;
    otherAllowance: number | null;
    bankName: string;
    bankNumber: string;
    bankAccountName: string;
    notes: string;
    bpjsKesehatan: number | null;
    bpjsTK: number | null;
    pTKPCategory: PTKPCategory;
    pph21: number | null;
    categoryTER: CategoryTER;
    grossSalary: number | null;
    nettSalary: number | null;
    file: File | null;
    photoProfile: string;
    previewUrl: string;
  }>({
    id: "",
    name: "",
    dateOfBirth: null,
    cityOfBirth: "",
    religion: "",
    address: "",
    phone: null,
    email: "",
    gender: "",
    maritalStatus: "",
    totalAnak: 0,
    nik: "",
    position: [],
    directorate: "",
    division: "",
    jobTitle: "",
    status: "",
    employeeType: "",
    office: "",
    company: "", // <-- Tambahkan ini
    dateOfJoining: null,
    expiredDate: null,
    taxIdNumber: "",
    salary: null,
    salaryCoefficient: null,
    salaryDelta: null,
    contributionAllowance: null,
    serviceAllowance: null,
    coachingAllowance: null,
    transportAllowance: null,
    housingAllowance: null,
    telecommunicationAllowance: null,
    positionAllowance: null,
    mobilePhoneAllowance: null,
    overtimeAllowance: null,
    naturaAllowance: null,
    otherAllowance: null,
    bankName: "",
    bankNumber: "",
    bankAccountName: "",
    notes: "",
    bpjsKesehatan: null,
    bpjsTK: null,
    pTKPCategory: "TK/0",
    categoryTER: "TER A",
    pph21: null,
    grossSalary: null,
    nettSalary: null,
    file: null,
    photoProfile: "",
    previewUrl: "",
  });

  const handleOpenEditDialog = async (id: number) => {
    setIsLoading(true);
    try {
      const data = await getEmployeeById(id);

      let previewUrl;
      if (data.photoProfile) {
        previewUrl = await fetchEmployeePhotoBlob(data.photoProfile);
      }

      // Normalisasi position ke bentuk array
      const normalizedPosition = Array.isArray(data.position)
        ? data.position
        : typeof data.position === "string" && data.position != ""
          ? JSON.parse(data.position) || []
          : data.position
            ? [data.position]
            : [];

      setEmployeeDataEdit({
        id: data.id,
        name: data.name,
        dateOfBirth: data.dateOfBirth || null,
        cityOfBirth: data.cityOfBirth,
        religion: data.religion,
        address: data.address,
        phone: data.phone || null,
        email: data.email,
        gender: data.gender,
        //maritalStatus: data.maritalStatus,
        //totalAnak: data.totalAnak || 0,
        nik: data.nik,
        position: normalizedPosition,
        directorate: data.directorate,
        division: data.division,
        jobTitle: data.jobTitle,
        status: data.status,
        employeeType: data.employeeType,
        office: data.office || "",
        company: data.company || "",
        dateOfJoining: data.dateOfJoining || null,
        expiredDate: data.expiredDate || null,
        taxIdNumber: data.taxIdNumber,
        salary: data.salary || null,
        salaryCoefficient: data.salaryCoefficient || null,
        salaryDelta: data.salaryDelta || null,
        contributionAllowance: data.contributionAllowance || null,
        serviceAllowance: data.serviceAllowance || null,
        coachingAllowance: data.pembinaan || null,
        transportAllowance: data.transportAllowance || null,
        housingAllowance: data.housingAllowance || null,
        telecommunicationAllowance: data.telkomAllowance || null,
        positionAllowance: data.positionAllowance || null,
        mobilePhoneAllowance: data.pulsaAllowance || null,
        overtimeAllowance: data.overtimeAllowance || null,
        naturaAllowance: data.naturaAllowance || null,
        otherAllowance: data.otherAllowance || null,
        bankName: data.bankName,
        bankNumber: data.bankNumber,
        bankAccountName: data.bankAccountName,
        notes: data.notes || "",
        bpjsKesehatan: data.potBpjsKes || null,
        bpjsTK: data.potBpjsTk || null,
        pTKPCategory: data.ptkpCategory || "",
        categoryTER: data.kategoriTER || getCategoryTERFromPTKP(data.ptkpCategory || "TK/0"),
        //pph21: data.potPph21 || null,
        grossSalary: data.grossSalary || null,
        nettSalary: data.netSalary || null,
        file: null,
        photoProfile: data.photoProfile || "",
        previewUrl: previewUrl,
      });

      setSelectedEmployeeId(id);
      setOpenEditEmployeeDialog(true);
      setIsEditing(false); // Pastikan mode edit dimatikan saat pertama kali dibuka
    } catch (error) {
      console.error("Failed to fetch employee data:", error);
      Swal.fire({
        icon: "error",
        title: "Gagal memuat data karyawan",
        text:
          error instanceof Error
            ? error.message
            : "Terjadi kesalahan yang tidak diketahui",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const getStatusClass = (status: string) => {
    switch (status) {
      case "Resign":
        return "statusRed";
      case "Probation":
        return "statusGray";
      case "Contract":
        return "statusGray";
      case "Active":
        return "statusGreen";
      default:
        return "";
    }
  };

  const calculateSalariesEdit = (data: any) => {
    // Konversi semua nilai ke number dengan default 0 jika null/undefined
    const salary = Number(data.salary) || 0;
    const coefficient = Number(data.salaryCoefficient) || 1;
    const delta = Number(data.salaryDelta) || 0;
    const basicSalary = Number(salary + data.serviceAllowance) || 0;

    // Hitung total allowances dengan konversi ke number
    const totalAllowances =
      (Number(data.contributionAllowance) || 0) +
      (Number(data.serviceAllowance) || 0) +
      (Number(data.coachingAllowance) || 0) +
      (Number(data.transportAllowance) || 0) +
      (Number(data.housingAllowance) || 0) +
      (Number(data.positionAllowance) || 0) +
      (Number(data.telecommunicationAllowance) || 0) +
      (Number(data.mobilePhoneAllowance) || 0) +
      (Number(data.overtimeAllowance) || 0) +
      (Number(data.naturaAllowance) || 0) +
      (Number(data.otherAllowance) || 0);

    // Hitung Gross Salary
    const grossSalary = parseFloat(((coefficient * salary) + (delta * salary) + totalAllowances).toFixed(2));

    // Hitung BPJS Kesehatan (1% dari gaji pokok)
    const bpjsKesehatan = (basicSalary) * 0.01;

    // Hitung BPJS Ketenagakerjaan (2% JHT + 1% JP)
    const bpjsTK = (basicSalary) * 0.03;

    console.log("bpjstk", bpjsTK);

    // Hitung Nett Salary
    const nettSalary = parseFloat((basicSalary).toFixed(2));

    console.log("tes", nettSalary, bpjsKesehatan, bpjsTK);

    return {
      bpjsKesehatan: parseFloat(bpjsKesehatan.toFixed(2)),
      bpjsTK: parseFloat(bpjsTK.toFixed(2)),
      grossSalary: parseFloat(grossSalary.toFixed(2)),
      nettSalary: parseFloat(nettSalary.toFixed(2))
    };
  };

  // Handler untuk perubahan salary
  const handleSalaryChangeEdit = (field: string, value: string | number | null, setData: Function, currentData: any) => {
    // Handle empty string case (when user clears the input)
    const numericValue = value === '' || value === null ? null : Number(value);

    // Only proceed if the value is a valid number or null
    if (numericValue === null || !isNaN(numericValue)) {
      const newData = {
        ...currentData,
        [field]: numericValue
      };

      const calculated = calculateSalariesEdit(newData);

      setData({
        ...newData,
        ...calculated
      });
    }
  };

  // Handler untuk perubahan PTKP
  const handlePTKPChangeEdit = (e: React.ChangeEvent<{ value: unknown }>) => {
    const value = e.target.value as PTKPCategory;

    setEmployeeDataEdit(prev => {
      const newData = {
        ...prev,
        pTKPCategory: value,
        categoryTER: getCategoryTERFromPTKP(value)
      };

      // Hitung ulang nilai yang tergantung
      const calculated = calculateSalariesEdit(newData);

      return {
        ...newData,
        ...calculated
      };
    });
  };

  const handleChangeEdit = (event) => {
    setEmployeeDataEdit(event.target.value);
  };

  const handleInputChangeEdit = (
    event:
      | React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
      | { target: { name: string; value: any } }
  ) => {
    const { name, value } = event.target;

    // Special handling for salary coefficient (decimal number field)
    if (name === "salaryCoefficient") {
      // Allow empty string or valid decimal number format
      if (value === "" || /^\d*\.?\d*$/.test(value)) {
        setEmployeeDataEdit((prevState) => ({
          ...prevState,
          [name]: value,
        }));
      }
      return;
    }

    // Handle marital status change separately
    if (name === "maritalStatus") {
      setEmployeeDataEdit((prevState) => ({
        ...prevState,
        [name]: value,
        ...(value !== "Married" ? { totalAnak: 0 } : {}),
      }));
      return;
    }

    // Default handling for all other fields
    setEmployeeDataEdit((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleEditFileUpload = (file) => {
    const validTypes = ["image/png", "image/jpeg", "image/jpg"];
    const maxSize = 5 * 1024 * 1024; // 5MB

    if (!validTypes.includes(file.type)) {
      Swal.fire({
        icon: "warning",
        title: "Format tidak didukung",
        text: "Hanya file .png, .jpg, dan .jpeg yang diperbolehkan",
      });
      return;
    }

    if (file.size > maxSize) {
      Swal.fire({
        icon: "warning",
        title: "Ukuran file terlalu besar",
        text: "Ukuran maksimum adalah 5MB",
      });
      return;
    }

    setEmployeeDataEdit({ ...employeeDataEdit, file });
  };

  const handleCloseEdit = () => {
    setOpenEditEmployeeDialog(false);
    setIsEditing(false); // Reset mode edit saat ditutup
    setSelectedEmployeeId(null);
  };

  // Handler functions:
  const handleDirectorateChangeEdit = (event: any) => {
    const directorate = event.target.value;
    const divisions = positionData[directorate] || {};

    setEmployeeDataEdit({
      ...employeeDataEdit,
      directorate,
      division: "",
      jobTitle: "",
    });
  };

  const handleDivisionChangeEdit = (event: any) => {
    setEmployeeDataEdit({
      ...employeeDataEdit,
      division: event.target.value,
      jobTitle: "",
    });
  };

  const handleJobTitleChangeEdit = (event: any) => {
    setEmployeeDataEdit({
      ...employeeDataEdit,
      jobTitle: event.target.value,
    });
  };

  // 1. Pastikan divisionsEdit selalu berupa array
  const divisionsEdit = employeeDataEdit.directorate
    ? Array.isArray(positionData[employeeDataEdit.directorate])
      ? positionData[employeeDataEdit.directorate]
      : Object.keys(positionData[employeeDataEdit.directorate] || {})
    : [];

  // 2. Handle case ketika jobTitlesEdit bukan array
  const jobTitlesEdit =
    employeeDataEdit.directorate && employeeDataEdit.division
      ? Array.isArray(
        positionData[employeeDataEdit.directorate][employeeDataEdit.division]
      )
        ? positionData[employeeDataEdit.directorate][employeeDataEdit.division]
        : []
      : [];

  const handleFileChangeEdit = (event) => {
    setEmployeeDataEdit((prevData) => ({
      ...prevData,
      file: event.target.files[0],
    }));
  };

  const handleFetchEmployee = async (id: number) => {
    setIsLoading(true);
    try {
      const token = localStorage.getItem("token");
      if (!token) throw new Error("Unauthorized: Token tidak ditemukan");

      const data = await getEmployeeById(id);

      let previewUrl: string | null = null;
      if (data.photoProfile && typeof data.photoProfile === "string") {
        previewUrl = await fetchEmployeePhotoBlob(data.photoProfile);
      }

      setEmployeeDataEdit({
        ...data,
        file: null,
        previewUrl: previewUrl,
      });
      await console.log(data);
    } catch (error) {
      console.error("Gagal memuat data karyawan:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleRowClick = async (
    event: React.MouseEvent,
    id: number,
    employee
  ) => {
    if ((event.target as HTMLElement).closest("input[type='checkbox']")) {
      return;
    }
    handleOpenEditDialog(id);
  };

  const [errorsEdit, setErrorsEdit] = useState({
    name: false,
    dateOfBirth: false,
    cityOfBirth: false,
    religion: false,
    address: false,
    phone: false,
    email: false,
    gender: false,
    maritalStatus: false,
    employeeID: false,
    position: false,
    directorate: false,
    division: false,
    jobTitle: false,
    employeeStatus: false,
    employeeType: false,
    office: false,
    company: false,
    dateOfJoining: false,
    expiredDate: false,
    taxIdNumber: false,
    salary: false,
    salaryCoefficient: false,
    salaryDelta: false,
    contributionAllowance: false,
    serviceAllowance: false,
    coachingAllowance: false,
    transportAllowance: false,
    housingAllowance: false,
    telecommunicationAllowance: false,
    positionAllowance: false,
    mobilePhoneAllowance: false,
    overtimeAllowance: false,
    naturaAllowance: false,
    otherAllowance: false,
    bankName: false,
    bankNumber: false,
    bankAccountName: false,
  });

  const validateFormEdit = () => {
    const newErrors: any = {};

    const mandatoryFields = [
      "name",
      "dateOfBirth",
      "cityOfBirth",
      "religion",
      "address",
      "phone",
      "email",
      "gender",
      //"maritalStatus",
      "nik",
      "position",
      "directorate",
      "division",
      "jobTitle",
      "status",
      "employeeType",
      //"office",
      "dateOfJoining",
      "taxIdNumber",
      "salary",
      "bankName",
      "bankNumber",
      "bankAccountName",
      //"notes",
    ];

    // Jika menikah → wajib isi total anak
    if (employeeDataEdit.maritalStatus === "Married") {
      mandatoryFields.push("totalAnak");
    }

    // Jika tipe inorganic → wajib isi vendor company
    if (employeeDataEdit.employeeType === "Inorganic") {
      mandatoryFields.push("company");
    }

    // Validasi setiap field
    mandatoryFields.forEach((field) => {
      if (
        !employeeDataEdit[field] ||
        employeeDataEdit[field].toString().trim() === ""
      ) {
        newErrors[field] = true;
      }
    });

    setErrorsEdit(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSaveEdit = async () => {
    if (!validateFormEdit()) {
      showPopupMandatoryError();
      return;
    }

    try {
      // 1. Dapatkan data employee yang lama
      const oldEmployeeData = await getEmployeeById(selectedEmployeeId);

      // 2. Dapatkan userId
      let userId = oldEmployeeData.userId;
      if (!userId) {
        try {
          const userInfo = await getUserInfoByEmail(oldEmployeeData.email);
          userId = userInfo.id;
          if (!userId) {
            throw new Error("User ID tidak ditemukan");
          }
        } catch (error) {
          Swal.fire({
            icon: "error",
            title: "User tidak ditemukan",
            text: `Tidak dapat menemukan user dengan email ${oldEmployeeData.email}`,
          });
          return;
        }
      }

      // 3. Fungsi untuk ekstrak nama role saja
      const extractRoleNames = (roles) => {
        if (!roles) return [];

        // Parse jika berupa string JSON
        let parsedRoles = Array.isArray(roles)
          ? roles
          : typeof roles === "string"
            ? JSON.parse(roles)
            : [];

        // Pastikan selalu array
        if (!Array.isArray(parsedRoles)) parsedRoles = [parsedRoles];

        // Filter dan map untuk dapatkan hanya nama role
        return parsedRoles
          .map((role) => {
            // Jika role adalah object, cari property name
            if (typeof role === "object" && role !== null) {
              return role.name || role.roleName || role.role;
            }
            // Jika berupa string dengan format ["roleName", "userId"], ambil roleName saja
            if (
              typeof role === "string" &&
              role.startsWith('"') &&
              role.includes(",")
            ) {
              return role.split(",")[0].replace(/"/g, "").trim();
            }
            // Jika sudah berupa string biasa (nama role)
            return role;
          })
          .filter((role) => typeof role === "string" && role.length > 0); // Hanya string non-empty
      };

      // 4. Ekstrak nama role dari data lama dan baru
      const cleanOldRoles = extractRoleNames(oldEmployeeData.position);
      const cleanNewRoles = extractRoleNames(employeeDataEdit.position);

      // 5. Cari perbedaan roles
      const rolesToUnassign = cleanOldRoles.filter(
        (role) => !cleanNewRoles.includes(role)
      );
      const rolesToAssign = cleanNewRoles.filter(
        (role) => !cleanOldRoles.includes(role)
      );

      // 6. Unassign roles jika diperlukan
      if (rolesToUnassign.length > 0) {
        await unassignRoleFromUser(
          oldEmployeeData.email,
          userId,
          rolesToUnassign
        );
      }

      // 7. Update data employee
      const updatedEmployeeData = {
        ...employeeDataEdit,
        userId: userId,
        position: cleanNewRoles, // Hanya nama role yang disimpan
      };
      await updateEmployee(selectedEmployeeId, updatedEmployeeData);

      // 8. Assign roles baru jika diperlukan
      if (rolesToAssign.length > 0) {
        await assignRolesToUser(userId, oldEmployeeData.email, rolesToAssign);
      }

      // 9. Upload foto jika ada perubahan
      if (
        employeeDataEdit.file &&
        employeeDataEdit.file.name !== employeeDataEdit.photoProfile
      ) {
        await uploadItemPhoto(selectedEmployeeId, employeeDataEdit.file);
      }

      // 10. Tampilkan notifikasi sukses
      Swal.fire({
        icon: "success",
        title: "Update data karyawan sukses",
        html: `
          <div>
            <p>Data karyawan tersimpan</p>
            ${rolesToAssign.length > 0
            ? `<p>Assigned roles: ${rolesToAssign.join(", ")}</p>`
            : ""
          }
            ${rolesToUnassign.length > 0
            ? `<p>Unassigned roles: ${rolesToUnassign.join(", ")}</p>`
            : ""
          }
          </div>
        `,
        confirmButtonColor: "#0F62FE",
      });

      setOpenEditEmployeeDialog(false);
      reloadEmployee();
    } catch (error: any) {
      console.error("Error saat menyimpan data:", error);

      let errorTitle = "Gagal memperbarui data karyawan";
      let errorDetails = "";

      // Penanganan error dari backend
      if (error.response?.data) {
        const backendError = error.response.data;
        errorTitle = backendError.error || errorTitle;

        // Handle khusus untuk error validasi email
        if (
          backendError.details &&
          /validation isEmail on email failed/i.test(backendError.details)
        ) {
          errorTitle = "Format Email Tidak Valid";
          errorDetails =
            "Harap masukkan alamat email yang benar (contoh: nama@perusahaan.com)";
        }
        // Handle error validasi lainnya
        else if (backendError.errors) {
          errorDetails = Object.values(backendError.errors)
            .map((err: any) => {
              // Custom message untuk error email
              if (err.path === "email" && err.validatorKey === "isEmail") {
                return "Format email tidak valid (contoh: nama@perusahaan.com)";
              }
              return err.message;
            })
            .join(", ");
        } else {
          errorDetails = backendError.details || "";
          setOpenEditEmployeeDialog(false);
        }
      }
      // Penanganan error dari frontend
      else if (error.message) {
        errorDetails = error.message;
        setOpenEditEmployeeDialog(false);
      }

      // Tampilkan error dalam Swal
      Swal.fire({
        icon: "error",
        title: errorTitle,
        html: `
          <div style="text-align: left;">
            <p><strong>${errorTitle}</strong></p>
            ${errorDetails
            ? `
              <div style="
                color: #d32f2f;
                background: #ffebee;
                padding: 10px;
                border-radius: 4px;
                margin-top: 8px;
                font-size: 0.9em;
              ">
                ${errorDetails.replace(/\n/g, "<br>")}
              </div>
            `
            : ""
          }
          </div>
        `,
        confirmButtonColor: "#0F62FE",
      });
    }
  };

  const handleRemoveRoleEdit = (index: number) => {
    const updatedPosition = [...employeeDataEdit.position];
    updatedPosition.splice(index, 1);
    setEmployeeDataEdit({
      ...employeeDataEdit,
      position: updatedPosition,
    });
  };

  const handleAddRoleEdit = () => {
    if (!newRole) return;

    // Cek apakah role sudah ada
    if (employeeDataEdit.position?.includes(newRole)) {
      Swal.fire({
        icon: "warning",
        title: "Role sudah diassign",
        text: "Role ini sudah diassign kepada karyawan",
      });
      return;
    }

    // Tambahkan role baru
    setEmployeeDataEdit((prev) => ({
      ...prev,
      position: [...(prev.position || []), newRole],
    }));

    // Reset dropdown
    setNewRole("");
  };

  useEffect(() => {
    if (openEditEmployeeDialog && selectedEmployeeId) {
      const loadRoles = async () => {
        try {
          const rolesData = await fetchRoles();
          setRoles(rolesData);
        } catch (error) {
          console.error("Gagal memuat roles:", error);
        }
      };
      loadRoles();
    }
  }, [openEditEmployeeDialog, selectedEmployeeId]);

  // Memanggil data saat komponen pertama kali dimuat
  useEffect(() => {
    reloadEmployee();
  }, [currentPage, rowsPerPage, filterParams, sortConfig]);

  useEffect(() => {
    // Set office filter options
    setOfficeFilterOptions(
      offices.map((office) => ({
        officeId: office.officeId,
        officeName: office.officeName,
      }))
    );

    // Set vendor filter options
    setVendorFilterOptions(
      vendors.map((vendor) => ({
        vendorId: vendor.vendorId,
        vendorName: vendor.vendorName,
      }))
    );
  }, [offices, vendors]);

  useEffect(() => {
    const loadRoles = async () => {
      setLoadingRoles(true);
      try {
        const rolesData = await fetchRoles();
        setRoles(rolesData);
      } catch (error) {
        console.error("Gagal memuat roles:", error);
      } finally {
        setLoadingRoles(false);
      }
    };

    loadRoles();

    const loadVendors = async () => {
      setLoadingVendors(true);
      try {
        const vendorsData = await fetchVendors();
        setVendors(vendorsData);
      } catch (error) {
        console.error("Gagal memuat vendors:", error);
      } finally {
        setLoadingVendors(false);
      }
    };

    loadVendors();

    const loadOffices = async () => {
      setLoadingOffices(true);
      try {
        const officesData = await fetchOffices();
        setOffices(officesData);
      } catch (error) {
        console.error("Gagal memuat office:", error);
      } finally {
        setLoadingOffices(false);
      }
    };

    loadOffices();
  }, []);

  // ======================================== end of function ========================================================
  // ============================================ start ui ===========================================================

  return isLoading ? (
    <LoadingOverlay />
  ) : (
    <Box sx={{ padding: 3 }}>
      {/* Header & Tabs */}
      <Box
        sx={{ display: "flex", alignItems: "center", gap: 2, marginBottom: 2 }}
      >
        <Typography variant="h6" fontWeight="bold">
          Employee List
        </Typography>
      </Box>

      {/* Toolbar */}
      <Box className="toolbar">
        {/* Left Controls */}
        <Box className="leftControls">
          <Typography>Show</Typography>
          <Select
            value={rowsPerPage}
            onChange={(e) => {
              setRowsPerPage(Number(e.target.value));
              setCurrentPage(1); // reset ke halaman 1 saat ganti limit
            }}
            size="small"
          >
            <MenuItem value={10}>10</MenuItem>
            <MenuItem value={25}>25</MenuItem>
            <MenuItem value={50}>50</MenuItem>
          </Select>

          {/* Search Button & Input */}
          <Button
            variant="contained"
            startIcon={<Search />}
            onClick={() => setShowSearch((prev) => !prev)}
            className="searchButton"
          >
            Search
          </Button>
          {showSearch && (
            <TextField
              variant="outlined"
              size="small"
              placeholder="Search"
              value={searchQuery}
              onChange={async (e) => {
                await setSearchQuery(e.target.value);
              }}
              onKeyPress={(e) => e.key === "Enter" && handleSearch()} // Pencarian dengan Enter
              autoFocus
              className="searchInput"
            />
          )}

          {/* Menampilkan Error */}
          {error && <p style={{ color: "red" }}>{error}</p>}
        </Box>

        {/* Right Controls */}
        <Box className="rightControls">
          <Button
            startIcon={<Delete />}
            variant="text"
            onClick={() => handleDeleteEmployee(true)} // Pindahkan fungsi delete di sini
            disabled={selectedRows.length === 0} // Disable jika tidak ada baris yang dipilih
          >
            Delete
          </Button>

          {/* Filter Button */}
          <Button
            startIcon={<FilterList />}
            variant="text"
            onClick={() => setOpenFilterDialog(true)}
          >
            Filters
          </Button>

          <Button
            startIcon={<Download />}
            variant="contained"
            className="exportButton"
            onClick={handleExport}
          >
            Export
          </Button>

          <Button
            startIcon={<Add />}
            variant="contained"
            className="addCategoryButton"
            onClick={handleOpenAddDialog} // Ganti dari setOpenAddEmployeeDialog
          >
            Add New Employee
          </Button>
        </Box>
      </Box>

      {/* Delete Button & Subtitle */}
      {/* <Box className="deleteContainer">
        <IconButton
          onClick={() => setOpenDeleteDialog(true)}
          disabled={selectedRows.length === 0} // Disable jika tidak ada baris yang dipilih
          className="deleteButton"
        >
          <TrashOutline color={"#333"} height="20px" width="20px" />
        </IconButton>
      </Box> */}

      <Box className="deleteContainer">
        <Typography variant="body2" className="detailsSubtitle">
          Details List Of Employee
        </Typography>
      </Box>

      {/* Table */}
      <TableContainer component={Paper} className="tableContainer">
        <Table className="table">
          <TableHead className="tableHead">
            <TableRow>
              <TableCell padding="checkbox" className="tableCell">
                <Checkbox
                  indeterminate={
                    selectedRows.length > 0 && selectedRows.length < rows.length
                  }
                  checked={selectedRows.length === rows.length}
                  onChange={() =>
                    setSelectedRows(
                      selectedRows.length === rows.length
                        ? []
                        : rows.map((row) => row.id)
                    )
                  }
                />
              </TableCell>
              <TableCell className="tableCell" width="50px">
                <strong>No</strong>
              </TableCell>
              <TableCell
                className="tableCell"
                onClick={() => handleSort("name")}
                style={{ cursor: "pointer" }}
              >
                <strong>Employee Name</strong>
                {sortConfig.orderBy === "name" &&
                  (sortConfig.order === "asc" ? " ▲" : " ▼")}
              </TableCell>
              <TableCell
                className="tableCell"
                onClick={() => handleSort("nik")}
                style={{ cursor: "pointer" }}
              >
                <strong>Employee Number</strong>
                {sortConfig.orderBy === "nik" &&
                  (sortConfig.order === "asc" ? " ▲" : " ▼")}
              </TableCell>
              <TableCell
                className="tableCell"
                onClick={() => handleSort("jobTitle")}
                style={{ cursor: "pointer" }}
              >
                <strong>Employee Job Title</strong>
                {sortConfig.orderBy === "jobTitle" &&
                  (sortConfig.order === "asc" ? " ▲" : " ▼")}
              </TableCell>
              <TableCell
                className="tableCell"
                onClick={() => handleSort("division")}
                style={{ cursor: "pointer" }}
              >
                <strong>Employee Division</strong>
                {sortConfig.orderBy === "division" &&
                  (sortConfig.order === "asc" ? " ▲" : " ▼")}
              </TableCell>
              <TableCell
                className="tableCell"
                onClick={() => handleSort("office")}
                style={{ cursor: "pointer" }}
              >
                <strong>Employee Office Location</strong>
                {sortConfig.orderBy === "office" &&
                  (sortConfig.order === "asc" ? " ▲" : " ▼")}
              </TableCell>
              <TableCell
                className="tableCell"
                onClick={() => handleSort("company")}
                style={{ cursor: "pointer" }}
              >
                <strong>Employee Vendor</strong>
                {sortConfig.orderBy === "company" &&
                  (sortConfig.order === "asc" ? " ▲" : " ▼")}
              </TableCell>
              <TableCell
                className="tableCell"
                onClick={() => handleSort("status")}
                style={{ cursor: "pointer" }}
              >
                <strong>Employee Status</strong>
                {sortConfig.orderBy === "status" &&
                  (sortConfig.order === "asc" ? " ▲" : " ▼")}
              </TableCell>
              <TableCell
                className="tableCell"
                onClick={() => handleSort("employeeType")}
                style={{ cursor: "pointer" }}
              >
                <strong>Employee Type</strong>
                {sortConfig.orderBy === "employeeType" &&
                  (sortConfig.order === "asc" ? " ▲" : " ▼")}
              </TableCell>
              <TableCell className="tableCell"></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {isLoading ? (
              <TableRow>
                <TableCell colSpan={10} align="center">
                  Loading...
                </TableCell>
              </TableRow>
            ) : error ? (
              <TableRow>
                <TableCell colSpan={10} align="center" style={{ color: "red" }}>
                  {error}
                </TableCell>
              </TableRow>
            ) : (
              rows.map((row, index) => (
                <TableRow key={row.id} selected={selectedRows.includes(row.id)}>
                  <TableCell padding="checkbox">
                    <Checkbox
                      checked={selectedRows.includes(row.id)}
                      onChange={(event) => {
                        event.stopPropagation();
                        handleSelectRow(row.id);
                      }}
                    />
                  </TableCell>
                  <TableCell>
                    {/* Nomor urut disesuaikan dengan pagination */}
                    {offset + index + 1}
                  </TableCell>
                  <TableCell>
                    <strong>{row.name}</strong>
                  </TableCell>
                  <TableCell>{row.nik}</TableCell>
                  <TableCell>{row.jobTitle}</TableCell>
                  <TableCell>{row.division}</TableCell>
                  <TableCell>
                    {offices.find((office) => office.officeId === row.office)
                      ?.officeName || "-"}
                  </TableCell>
                  <TableCell>
                    {vendors.find((vendor) => vendor.vendorId === row.company)
                      ?.vendorName || "-"}
                  </TableCell>
                  <TableCell>
                    <Box
                      className={`statusBadge ${getStatusClass(row.status)}`}
                    >
                      {row.status}
                    </Box>
                  </TableCell>
                  <TableCell>
                    <Box
                      className={`statusBadge ${row.employeeType === "Organic"
                        ? "typeGreen"
                        : "typeGray"
                        }`}
                    >
                      {row.employeeType}
                    </Box>
                  </TableCell>
                  <TableCell>
                    <IconButton
                      onClick={(event) => {
                        event.stopPropagation();
                        handleOpenEditDialog(row.id); // Ganti dari setOpenEditEmployeeDialog
                      }}
                    >
                      <MoreVert />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Pagination */}
      <Box
        className="paginationContainer"
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          width: "100%",
          padding: "16px 0",
        }}
      >
        {/* Info jumlah data */}
        <Typography variant="body2" sx={{ color: "text.secondary" }}>
          {`Showing ${offset + 1} to ${Math.min(
            offset + rowsPerPage,
            totalItems
          )} of ${totalItems} entries`}
        </Typography>

        {/* Komponen Pagination */}
        <Pagination
          count={totalPages}
          page={currentPage}
          onChange={(e, page) => setCurrentPage(page)}
          className="pagination"
          showFirstButton
          showLastButton
          renderItem={(item) => (
            <PaginationItem
              {...item}
              components={{ first: FirstPage, last: LastPage }}
            />
          )}
        />
      </Box>

      {/* ======================= Filter Dialog ============================= */}
      <Dialog
        open={openFilterDialog}
        onClose={() => setOpenFilterDialog(false)}
      >
        <DialogTitle>Advanced Search</DialogTitle>
        <DialogContent>
          {filters.map((filter, index) => {
            const usedFields = filters
              .map((f, i) => i !== index && f.field)
              .filter(Boolean);
            const availableOptions = availableFilters.filter(
              (opt) => !usedFields.includes(opt.value)
            );

            // Daftar nilai untuk status dan employee type
            const statusOptions = ["Active", "Probation", "Contract", "Resign"];
            const employeeTypeOptions = ["Organic", "Inorganic"];

            return (
              <Box
                key={index}
                display="flex"
                alignItems="center"
                gap={1}
                mb={2}
              >
                <TextField
                  select
                  value={filter.field}
                  onChange={(e) =>
                    handleFilterChange(index, "field", e.target.value)
                  }
                  variant="outlined"
                  size="small"
                  sx={{ mt: 1, minWidth: 160 }}
                >
                  {availableOptions.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>

                {(() => {
                  if (filter.field === "office") {
                    return (
                      <Autocomplete
                        options={officeFilterOptions}
                        getOptionLabel={(option) => option.officeName}
                        value={officeFilterOptions.find(
                          (opt) => opt.officeName === filter.value
                        )}
                        onChange={(event, newValue) => {
                          const newFilters = [...filters];
                          newFilters[index].value = newValue?.officeName || "";
                          setFilters(newFilters);
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Office"
                            variant="outlined"
                            size="small"
                            sx={{ mt: 1, minWidth: 160 }}
                          />
                        )}
                        disableClearable
                        noOptionsText="No offices found"
                      />
                    );
                  } else if (filter.field === "company") {
                    return (
                      <Autocomplete
                        options={vendorFilterOptions}
                        getOptionLabel={(option) => option.vendorName}
                        value={vendorFilterOptions.find(
                          (opt) => opt.vendorName === filter.value
                        )}
                        onChange={(event, newValue) => {
                          const newFilters = [...filters];
                          newFilters[index].value = newValue?.vendorName || "";
                          setFilters(newFilters);
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Vendor Company"
                            variant="outlined"
                            size="small"
                            sx={{ mt: 1, minWidth: 160 }}
                          />
                        )}
                        disableClearable
                        noOptionsText="No vendors found"
                      />
                    );
                  } else if (filter.field === "status") {
                    return (
                      // Kode existing untuk status filter
                      <TextField
                        select
                        label="Status"
                        variant="outlined"
                        size="small"
                        value={filter.value}
                        onChange={(e) =>
                          handleFilterChange(index, "value", e.target.value)
                        }
                        sx={{ mt: 1, minWidth: 160 }}
                      >
                        {statusOptions.map((option) => (
                          <MenuItem key={option} value={option}>
                            {option.replace("_", " ")}
                          </MenuItem>
                        ))}
                      </TextField>
                    );
                  } else if (filter.field === "employeeType") {
                    return (
                      // Kode existing untuk employeeType filter
                      <TextField
                        select
                        label="Employee Type"
                        variant="outlined"
                        size="small"
                        value={filter.value}
                        onChange={(e) =>
                          handleFilterChange(index, "value", e.target.value)
                        }
                        sx={{ mt: 1, minWidth: 160 }}
                      >
                        {employeeTypeOptions.map((option) => (
                          <MenuItem key={option} value={option}>
                            {option.replace("_", " ")}
                          </MenuItem>
                        ))}
                      </TextField>
                    );
                  } else {
                    return (
                      // Default text field untuk filter lainnya
                      <TextField
                        label="Value"
                        variant="outlined"
                        size="small"
                        value={filter.value}
                        onChange={(e) =>
                          handleFilterChange(index, "value", e.target.value)
                        }
                        sx={{ mt: 1 }}
                      />
                    );
                  }
                })()}

                {index > 0 && (
                  <IconButton onClick={() => handleRemoveFilter(index)}>
                    <Remove />
                  </IconButton>
                )}
              </Box>
            );
          })}

          {filters.length < availableFilters.length && (
            <Button startIcon={<Add />} onClick={handleAddFilter}>
              Add Filter
            </Button>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleResetFilters}>Reset Filter</Button>
          <Button onClick={handleCloseFilter}>Cancel</Button>
          <Button
            variant="contained"
            onClick={handleApplyFilters}
            disabled={isLoading}
          >
            {isLoading ? "Loading..." : "Apply"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* ================== POPUP Add New Employee =========================== */}
      <Dialog
        open={openAddEmployeeDialog}
        onClose={() => setOpenAddEmployeeDialog(false)}
        fullWidth
        maxWidth="lg"
        sx={{ backdropFilter: "blur(5px)" }}
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="h6" fontWeight="bold">
            Add New Employee
          </Typography>
          <IconButton onClick={handleCloseAdd} color="error">
            <Close />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={3}>
            {/* Profile Picture & Employee ID */}
            <Grid item xs={12} sm={4}>
              <Typography variant="subtitle1" fontWeight="bold">
                PERSONAL DETAILS
              </Typography>
              <Box
                sx={{
                  flex: 1,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  border: "2px dashed #aaa",
                  padding: 4,
                  borderRadius: "12px",
                  backgroundColor: "#fafafa",
                  textAlign: "center",
                  cursor: "pointer",
                  position: "relative",
                }}
                onClick={() => fileInputRef.current?.click()}
              >
                {previewUrl ? (
                  <img
                    src={previewUrl}
                    alt="Preview"
                    style={{
                      width: "100%",
                      height: "auto",
                      borderRadius: "8px",
                      objectFit: "contain",
                      maxHeight: 180,
                    }}
                  />
                ) : (
                  <>
                    <PhotoCamera fontSize="large" />
                    <Typography variant="body2" color="textSecondary" mt={1}>
                      Drag & drop or click to upload image
                    </Typography>
                  </>
                )}
                <input
                  hidden
                  accept="image/png, image/jpeg, image/jpg"
                  type="file"
                  ref={fileInputRef}
                  onChange={(e) => handleFileUpload(e.target.files[0])}
                />
                <Typography variant="caption" mt={1}>
                  Max size: 5MB (.png, .jpg, .jpeg)
                </Typography>
              </Box>

              <TextField
                fullWidth
                label="Employee Name"
                value={employeeDataAdd.name}
                sx={{ mb: 1, mt: 2 }}
                name="name"
                error={!employeeDataAdd.name}
                helperText={!employeeDataAdd.name ? "Mandatory Field" : ""}
                onChange={handleInputChangeAdd}
              />
              {/* Date Picker */}
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DesktopDatePicker
                  label="Date Of Birth"
                  format="YYYY-MM-DD"
                  value={
                    employeeDataAdd.dateOfBirth
                      ? dayjs(employeeDataAdd.dateOfBirth)
                      : null
                  }
                  onChange={(newValue) =>
                    handleInputChangeAdd({
                      target: {
                        name: "dateOfBirth",
                        value: newValue
                          ? dayjs(newValue).format("YYYY-MM-DD")
                          : "",
                      },
                    })
                  }
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      sx: { mb: 1 },
                      name: "dateOfBirth",
                      error: !employeeDataAdd.dateOfBirth,
                      helperText: !employeeDataAdd.dateOfBirth
                        ? "Mandatory Field"
                        : "",
                    },
                  }}
                />
              </LocalizationProvider>
              <TextField
                fullWidth
                label="Place Of Birth"
                value={employeeDataAdd.cityOfBirth}
                sx={{ mb: 1 }}
                name="cityOfBirth"
                error={!employeeDataAdd.cityOfBirth}
                helperText={
                  !employeeDataAdd.cityOfBirth ? "Mandatory Field" : ""
                }
                onChange={handleInputChangeAdd}
              />
              <TextField
                select
                fullWidth
                label="Religion"
                sx={{ textAlign: "left", mb: 1 }}
                value={employeeDataAdd.religion}
                name="religion"
                error={!employeeDataAdd.religion}
                helperText={!employeeDataAdd.religion ? "Mandatory Field" : ""}
                onChange={handleInputChangeAdd}
              >
                <MenuItem value="" disabled>
                  Select item
                </MenuItem>
                <MenuItem value="Islam">Islam</MenuItem>
                <MenuItem value="Christian">Kristen Protestan</MenuItem>
                <MenuItem value="Catholic">Kristen Katolik</MenuItem>
                <MenuItem value="Hindu">Hindu</MenuItem>
                <MenuItem value="Buddha">Buddha</MenuItem>
                <MenuItem value="Konghucu">Konghucu</MenuItem>
              </TextField>
              <Typography
                variant="body2"
                color="textSecondary"
                sx={{ textAlign: "left" }}
              >
                Employee Address
              </Typography>
              <TextField
                fullWidth
                multiline
                rows={3}
                placeholder="Enter employee address"
                sx={{ textAlign: "left", mt: 1, mb: 2 }}
                value={employeeDataAdd.address}
                name="address"
                error={!employeeDataAdd.address}
                helperText={!employeeDataAdd.address ? "Mandatory Field" : ""}
                onChange={handleInputChangeAdd}
              />
              <TextField
                fullWidth
                type="number"
                label="Phone Number"
                value={employeeDataAdd.phone}
                sx={{ mb: 1 }}
                name="phone"
                error={!employeeDataAdd.phone}
                helperText={!employeeDataAdd.phone ? "Mandatory Field" : ""}
                onChange={handleInputChangeAdd}
              />
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <TextField
                    select
                    fullWidth
                    label="Gender"
                    sx={{ textAlign: "left", mt: 1, mb: 1 }}
                    value={employeeDataAdd.gender}
                    name="gender"
                    error={!employeeDataAdd.gender}
                    helperText={
                      !employeeDataAdd.gender ? "Mandatory Field" : ""
                    }
                    onChange={handleInputChangeAdd}
                  >
                    <MenuItem value="" disabled>
                      Select item
                    </MenuItem>
                    <MenuItem value="Male">Laki-Laki</MenuItem>
                    <MenuItem value="Female">Perempuan</MenuItem>
                  </TextField>
                </Grid>
                {/* <Grid item xs={6}>
                  <TextField
                    select
                    fullWidth
                    label="Marital Status"
                    sx={{ textAlign: "left", mt: 1, mb: 1 }}
                    value={employeeDataAdd.maritalStatus}
                    name="maritalStatus"
                    error={!employeeDataAdd.maritalStatus}
                    helperText={
                      !employeeDataAdd.maritalStatus ? "Mandatory Field" : ""
                    }
                    onChange={handleInputChangeAdd}
                  >
                    <MenuItem value="" disabled>
                      Select item
                    </MenuItem>
                    <MenuItem value="Single">Belum Menikah</MenuItem>
                    <MenuItem value="Married">Menikah</MenuItem>
                    <MenuItem value="Widow">Janda</MenuItem>
                    <MenuItem value="Widower">Duda</MenuItem>
                  </TextField>
                </Grid>
                {(employeeDataAdd.maritalStatus === "Married" ||
                  employeeDataAdd.maritalStatus === "Widow" ||
                  employeeDataAdd.maritalStatus === "Widower") && (
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        type="number"
                        label="Total Jumlah Anak"
                        value={employeeDataAdd.totalAnak || ""}
                        name="totalAnak"
                        error={!employeeDataAdd.totalAnak}
                        helperText={
                          !employeeDataAdd.totalAnak ? "Mandatory Field" : ""
                        }
                        onChange={handleInputChangeAdd}
                      />
                    </Grid>
                  )} */}
              </Grid>
            </Grid>

            {/* Personal Details & Employment Profile */}
            <Grid item xs={12} sm={8}>
              <Grid container spacing={2}>
                {/* Personal Details */}
                <Grid item xs={12} sm={6}>
                  <Typography variant="subtitle1" fontWeight="bold">
                    EMPLOYMENT PROFILE
                  </Typography>
                  <TextField
                    fullWidth
                    label="Nomor Induk Karyawan"
                    value={employeeDataAdd.nik}
                    name="nik"
                    onChange={handleInputChangeAdd}
                    error={!employeeDataAdd.nik}
                    helperText={!employeeDataAdd.nik ? "Mandatory Field" : ""}
                  />
                  <Grid item xs={24} md={12} mb={2}>
                    <Box
                      sx={{
                        border: "1px solid #e0e0e0",
                        borderRadius: 1,
                        p: 2,
                        height: "100%",
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <Typography
                        variant="body2"
                        color="textSecondary"
                        sx={{ mb: 2 }}
                      >
                        Role List
                      </Typography>

                      <Box
                        sx={{
                          flexGrow: 1,
                          maxHeight: 200,
                          overflowY: "auto",
                          mb: 2,
                          p: 1,
                          backgroundColor: "#f9f9f9",
                          borderRadius: 1,
                        }}
                      >
                        {employeeDataAdd.position?.length > 0 ? (
                          employeeDataAdd.position.map((roleId, index) => {
                            const role = roles.find((r) => r.id === roleId);
                            return (
                              <Box
                                key={index}
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  mb: 1,
                                }}
                              >
                                <Chip
                                  label={role?.name || roleId}
                                  onDelete={() => handleRemoveRoles(index)}
                                  sx={{
                                    flexGrow: 1,
                                    "& .MuiChip-label": {
                                      whiteSpace: "nowrap",
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                    },
                                  }}
                                />
                              </Box>
                            );
                          })
                        ) : (
                          <Typography
                            variant="body2"
                            color="text.disabled"
                            sx={{ textAlign: "center", py: 2 }}
                          >
                            No role added
                          </Typography>
                        )}
                      </Box>

                      <Box sx={{ display: "flex", gap: 1 }}>
                        <Select
                          fullWidth
                          displayEmpty
                          value={newRole}
                          onChange={(e) => setNewRole(e.target.value as string)}
                          size="small"
                          sx={{
                            flexGrow: 1,
                            "& .MuiOutlinedInput-root": {
                              borderRadius: 1,
                            },
                          }}
                          disabled={loadingRoles}
                          MenuProps={{
                            PaperProps: {
                              style: {
                                maxHeight: 300,
                              },
                            },
                            // Tambahkan ini:
                            disableEnforceFocus: true, // Memungkinkan fokus tetap di input search
                            onKeyDown: (e) => {
                              // Mencegah Select menangkap event keyboard saat search aktif
                              if (
                                document.activeElement.id ===
                                "role-search-input"
                              ) {
                                e.stopPropagation();
                              }
                            },
                          }}
                        >
                          {/* Search Field */}
                          <Box
                            sx={{ p: 1 }}
                            onClick={(e) => e.stopPropagation()}
                          >
                            <TextField
                              id="role-search-input"
                              fullWidth
                              variant="outlined"
                              placeholder="Search roles..."
                              value={roleSearch}
                              onChange={(e) => setRoleSearch(e.target.value)}
                              onClick={(e) => {
                                e.stopPropagation();
                                e.currentTarget.focus();
                              }}
                              onKeyDown={(e) => e.stopPropagation()} // Tambahkan ini
                              InputProps={{
                                startAdornment: (
                                  <InputAdornment position="start">
                                    <Search fontSize="small" />
                                  </InputAdornment>
                                ),
                                endAdornment: roleSearch && (
                                  <InputAdornment position="end">
                                    <IconButton
                                      size="small"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        setRoleSearch("");
                                      }}
                                    >
                                      <Clear fontSize="small" />
                                    </IconButton>
                                  </InputAdornment>
                                ),
                                size: "small",
                              }}
                              sx={{
                                "& .MuiOutlinedInput-root": {
                                  paddingRight: 1,
                                },
                              }}
                              autoFocus // Tambahkan ini untuk fokus otomatis
                            />
                          </Box>

                          {/* Filtered Role List */}
                          {roles
                            .filter(
                              (option) =>
                                !employeeDataAdd.position.includes(option.id) &&
                                (option.name
                                  .toLowerCase()
                                  .includes(roleSearch.toLowerCase()) ||
                                  option.id
                                    .toLowerCase()
                                    .includes(roleSearch.toLowerCase()))
                            )
                            .map((option) => (
                              <MenuItem key={option.id} value={option.id}>
                                <Box
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 1,
                                  }}
                                >
                                  <Typography>{option.name}</Typography>
                                </Box>
                              </MenuItem>
                            ))}

                          {roles.filter(
                            (option) =>
                              !employeeDataAdd.position.includes(option.id) &&
                              (option.name
                                .toLowerCase()
                                .includes(roleSearch.toLowerCase()) ||
                                option.id
                                  .toLowerCase()
                                  .includes(roleSearch.toLowerCase()))
                          ).length === 0 && (
                              <MenuItem disabled>
                                <Typography
                                  variant="body2"
                                  color="text.secondary"
                                >
                                  No roles found
                                </Typography>
                              </MenuItem>
                            )}
                        </Select>
                        <Button
                          variant="contained"
                          onClick={handleAddRoles}
                          disabled={!newRole}
                          size="small"
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            lineHeight: "1.2",
                            py: 0.5,
                            minHeight: "unset",
                          }}
                        >
                          <span>Add</span>
                          <span>Role</span>
                        </Button>
                      </Box>
                    </Box>
                  </Grid>
                  <TextField
                    fullWidth
                    label="Email"
                    value={employeeDataAdd.email}
                    sx={{ mb: 1 }}
                    name="email"
                    error={!employeeDataAdd.email}
                    helperText={!employeeDataAdd.email ? "Mandatory Field" : ""}
                    onChange={handleInputChangeAdd}
                  />
                  {/* Directorate Field */}

                  <TextField
                    select
                    fullWidth
                    label="Directorate"
                    sx={{ textAlign: "left", mt: 1 }}
                    value={employeeDataAdd.directorate}
                    name="directorate"
                    error={!employeeDataAdd.directorate}
                    helperText={
                      !employeeDataAdd.directorate ? "Mandatory Field" : ""
                    }
                    onChange={handleDirectorateChangeAdd}
                  >
                    {Object.keys(positionData).map((directorate) => (
                      <MenuItem key={directorate} value={directorate}>
                        {directorate}
                      </MenuItem>
                    ))}
                  </TextField>

                  {/* Division Field */}
                  <TextField
                    select
                    fullWidth
                    label="Division"
                    sx={{ textAlign: "left", mt: 1 }}
                    value={employeeDataAdd.division}
                    name="division"
                    error={!employeeDataAdd.division}
                    helperText={
                      !employeeDataAdd.division ? "Mandatory Field" : ""
                    }
                    onChange={handleDivisionChangeAdd}
                    disabled={!employeeDataAdd.directorate}
                  >
                    {divisionsAdd.map((division) => (
                      <MenuItem key={division} value={division}>
                        {division}
                      </MenuItem>
                    ))}
                  </TextField>

                  {/* Job Title Field */}
                  <TextField
                    select
                    fullWidth
                    label="Job Title"
                    sx={{ textAlign: "left", mt: 1 }}
                    value={employeeDataAdd.jobTitle}
                    name="jobTitle"
                    error={!employeeDataAdd.jobTitle}
                    helperText={
                      !employeeDataAdd.jobTitle ? "Mandatory Field" : ""
                    }
                    onChange={handleJobTitleChangeAdd}
                    disabled={!employeeDataAdd.division}
                  >
                    {jobTitlesAdd.map((jobTitle) => (
                      <MenuItem key={jobTitle} value={jobTitle}>
                        {jobTitle}
                      </MenuItem>
                    ))}
                  </TextField>

                  <Grid container spacing={2}>
                    <Grid item xs={6}>
                      <TextField
                        select
                        fullWidth
                        label="Status"
                        sx={{ textAlign: "left", mt: 1, mb: 1 }}
                        value={employeeDataAdd.status}
                        name="status"
                        error={!employeeDataAdd.status}
                        helperText={
                          !employeeDataAdd.status ? "Mandatory Field" : ""
                        }
                        onChange={handleInputChangeAdd}
                      >
                        <MenuItem value="" disabled>
                          Select item
                        </MenuItem>
                        <MenuItem value="Active">Active</MenuItem>
                        <MenuItem value="Probation">Probation</MenuItem>
                        <MenuItem value="Contract">Contract</MenuItem>
                        <MenuItem value="Resign">Resign</MenuItem>
                      </TextField>
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        select
                        fullWidth
                        label="Employee Type"
                        sx={{ textAlign: "left", mt: 1, mb: 1 }}
                        value={employeeDataAdd.employeeType}
                        name="employeeType"
                        error={!employeeDataAdd.employeeType}
                        helperText={
                          !employeeDataAdd.employeeType ? "Mandatory Field" : ""
                        }
                        onChange={handleInputChangeAdd}
                      >
                        <MenuItem value="" disabled>
                          Select item
                        </MenuItem>
                        <MenuItem value="Organic">Organic</MenuItem>
                        <MenuItem value="Inorganic">Inorganic</MenuItem>
                      </TextField>
                    </Grid>
                  </Grid>
                  <Autocomplete
                    options={offices}
                    getOptionLabel={(option) => option.officeName || ""}
                    value={
                      offices.find(
                        (opt) => opt.officeId === employeeDataAdd.office
                      ) || null
                    }
                    onChange={(event, newValue) => {
                      handleInputChangeAdd({
                        target: {
                          name: "office",
                          value: newValue ? newValue.officeId : "",
                        },
                      });
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Office"
                        placeholder="Select Office"
                        margin="normal"
                        fullWidth
                        error={!employeeDataAdd.office}
                        helperText={
                          !employeeDataAdd.office ? "Mandatory Field" : ""
                        }
                        disabled={loadingOffices}
                      />
                    )}
                    loading={loadingOffices}
                    loadingText="Loading offices..."
                    noOptionsText={
                      offices.length === 0
                        ? "No offices available"
                        : "No matching offices found"
                    }
                  />

                  {employeeDataAdd.employeeType === "Inorganic" && (
                    <Autocomplete
                      options={vendors}
                      getOptionLabel={(option) => option.vendorName || ""}
                      value={
                        vendors.find(
                          (v) => v.vendorId === employeeDataAdd.company
                        ) || null
                      }
                      onChange={(event, newValue) => {
                        handleInputChangeAdd({
                          target: {
                            name: "company",
                            value: newValue ? newValue.vendorId : "",
                          },
                        });
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Vendor Company"
                          placeholder="Select Vendor"
                          margin="normal"
                          fullWidth
                          sx={{ mt: 1 }}
                          error={!employeeDataAdd.company}
                          helperText={
                            !employeeDataAdd.company ? "Mandatory Field" : ""
                          }
                          disabled={loadingVendors}
                        />
                      )}
                      loading={loadingVendors}
                      loadingText="Loading vendors..."
                      noOptionsText={
                        vendors.length === 0
                          ? "No vendors available"
                          : "No matching vendors found"
                      }
                    />
                  )}
                </Grid>

                {/* Employment Profile */}
                <Grid item xs={12} sm={6}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DesktopDatePicker
                      label="Date Joining"
                      format="YYYY-MM-DD"
                      value={
                        employeeDataAdd.dateOfJoining
                          ? dayjs(employeeDataAdd.dateOfJoining)
                          : null
                      }
                      onChange={(newValue) =>
                        handleInputChangeAdd({
                          target: {
                            name: "dateOfJoining",
                            value: newValue
                              ? dayjs(newValue).format("YYYY-MM-DD")
                              : "",
                          },
                        })
                      }
                      slotProps={{
                        textField: {
                          fullWidth: true,
                          sx: { mb: 1, mt: 3.5 },
                          name: "dateOfJoining",
                          error: !employeeDataAdd.dateOfJoining,
                          helperText: !employeeDataAdd.dateOfJoining
                            ? "Mandatory Field"
                            : "",
                        },
                      }}
                    />
                  </LocalizationProvider>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DesktopDatePicker
                      label="End of Contract"
                      format="YYYY-MM-DD"
                      value={
                        employeeDataAdd.expiredDate
                          ? dayjs(employeeDataAdd.expiredDate)
                          : null
                      }
                      onChange={(newValue) =>
                        handleInputChangeAdd({
                          target: {
                            name: "expiredDate",
                            value: newValue
                              ? dayjs(newValue).format("YYYY-MM-DD")
                              : "",
                          },
                        })
                      }
                      slotProps={{
                        textField: {
                          fullWidth: true,
                          sx: { mb: 1 },
                          name: "expiredDate",
                        },
                      }}
                    />
                  </LocalizationProvider>
                  <TextField
                    fullWidth
                    multiline
                    rows={3}
                    placeholder="Enter notes"
                    sx={{ textAlign: "left", mt: 1, mb: 2 }}
                    value={employeeDataAdd.notes}
                    name="notes"
                    onChange={handleInputChangeAdd}
                  />
                </Grid>
              </Grid>
            </Grid>

            {/* Divider - Garis Pemisah */}
            <Grid item xs={12} sm={8}>
              <Divider sx={{ my: 0, borderBottom: "2px solid #ddd" }} />
            </Grid>

            {/* Personal Salary Information */}
            <Grid item xs={12} sm={8}>
              <Typography
                variant="subtitle1"
                fontWeight="bold"
                sx={{ mt: -2, mb: 0.5 }}
              >
                PERSONAL SALARY INFORMATION
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    type="number"
                    label="No NPWP"
                    value={employeeDataAdd.taxIdNumber}
                    name="taxIdNumber"
                    error={!employeeDataAdd.taxIdNumber}
                    helperText={
                      !employeeDataAdd.taxIdNumber ? "Mandatory Field" : ""
                    }
                    onChange={handleInputChangeAdd}
                  />
                </Grid>
                <Grid item xs={6}>
                  <Autocomplete
                    options={bankData}
                    value={employeeDataAdd.bankName || null}
                    onChange={(event, newValue) => {
                      handleInputChangeAdd({
                        target: {
                          name: "bankName",
                          value: newValue || "",
                        },
                      });
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Bank Name"
                        placeholder="Select Bank"
                        fullWidth
                        error={!employeeDataAdd.bankName}
                        helperText={
                          !employeeDataAdd.bankName ? "Mandatory Field" : ""
                        }
                      />
                    )}
                    noOptionsText="No banks available"
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    type="number"
                    label="Salary"
                    value={employeeDataAdd.salary || ''}
                    onChange={(e) => {
                      const value = parseFloat(e.target.value);
                      handleSalaryChangeAdd('salary', isNaN(value) ? null : value, setEmployeeDataAdd, employeeDataAdd);
                    }}
                    InputProps={{
                      startAdornment: <InputAdornment position="start">Rp</InputAdornment>,
                      inputProps: {
                        step: "0.01",
                        min: "0"
                      }
                    }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    type="number"
                    label="Bank Account Number"
                    value={employeeDataAdd.bankNumber}
                    name="bankNumber"
                    error={!employeeDataAdd.bankNumber}
                    helperText={
                      !employeeDataAdd.bankNumber ? "Mandatory Field" : ""
                    }
                    onChange={handleInputChangeAdd}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    type="number"
                    label="Salary Coefficient"
                    value={employeeDataAdd.salaryCoefficient}
                    name="salaryCoefficient"
                    onChange={(e) => handleSalaryChangeAdd(
                      'salaryCoefficient',
                      parseFloat(e.target.value) || null,
                      setEmployeeDataAdd,
                      employeeDataAdd
                    )}
                    inputProps={{
                      step: "0.01",
                      min: "1",
                    }}
                    helperText="minimal 1%"
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    label="Bank Account Name"
                    value={employeeDataAdd.bankAccountName}
                    name="bankAccountName"
                    error={!employeeDataAdd.bankAccountName}
                    helperText={
                      !employeeDataAdd.bankAccountName ? "Mandatory Field" : ""
                    }
                    onChange={handleInputChangeAdd}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    type="number"
                    label="Salary Delta"
                    value={employeeDataAdd.salaryDelta}
                    name="salaryDelta"
                    onChange={(e) => handleSalaryChangeAdd(
                      'salaryDelta',
                      parseFloat(e.target.value) || null,
                      setEmployeeDataAdd,
                      employeeDataAdd
                    )}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    type="number"
                    label="Contribution Allowance"
                    value={employeeDataAdd.contributionAllowance}
                    name="contributionAllowance"
                    onChange={(e) => handleSalaryChangeAdd(
                      'contributionAllowance',
                      parseFloat(e.target.value) || null,
                      setEmployeeDataAdd,
                      employeeDataAdd
                    )}
                    InputProps={{
                      startAdornment: <InputAdornment position="start">Rp</InputAdornment>,
                      inputProps: {
                        step: "0.01",
                        min: "0"
                      }
                    }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    type="number"
                    label="Service Allowance"
                    value={employeeDataAdd.serviceAllowance}
                    name="serviceAllowance"
                    onChange={(e) => handleSalaryChangeAdd(
                      'serviceAllowance',
                      parseFloat(e.target.value) || null,
                      setEmployeeDataAdd,
                      employeeDataAdd
                    )}
                    InputProps={{
                      startAdornment: <InputAdornment position="start">Rp</InputAdornment>,
                      inputProps: {
                        step: "0.01",
                        min: "0"
                      }
                    }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    type="number"
                    label="Coaching Assistance"
                    value={employeeDataAdd.coachingAllowance}
                    name="coachingAllowance"
                    onChange={(e) => handleSalaryChangeAdd(
                      'coachingAllowance',
                      parseFloat(e.target.value) || null,
                      setEmployeeDataAdd,
                      employeeDataAdd
                    )}
                    InputProps={{
                      startAdornment: <InputAdornment position="start">Rp</InputAdornment>,
                      inputProps: {
                        step: "0.01",
                        min: "0"
                      }
                    }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    type="number"
                    label="Transport Assistance"
                    value={employeeDataAdd.transportAllowance}
                    name="transportAllowance"
                    onChange={(e) => handleSalaryChangeAdd(
                      'transportAllowance',
                      parseFloat(e.target.value) || null,
                      setEmployeeDataAdd,
                      employeeDataAdd
                    )}
                    InputProps={{
                      startAdornment: <InputAdornment position="start">Rp</InputAdornment>,
                      inputProps: {
                        step: "0.01",
                        min: "0"
                      }
                    }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    type="number"
                    label="Housing Assistance"
                    value={employeeDataAdd.housingAllowance}
                    name="housingAllowance"
                    onChange={(e) => handleSalaryChangeAdd(
                      'housingAllowance',
                      parseFloat(e.target.value) || null,
                      setEmployeeDataAdd,
                      employeeDataAdd
                    )}
                    InputProps={{
                      startAdornment: <InputAdornment position="start">Rp</InputAdornment>,
                      inputProps: {
                        step: "0.01",
                        min: "0"
                      }
                    }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    type="number"
                    label="Telecommunication Assistance"
                    value={employeeDataAdd.telecommunicationAllowance}
                    name="telecommunicationAllowance"
                    onChange={(e) => handleSalaryChangeAdd(
                      'telecommunicationAllowance',
                      parseFloat(e.target.value) || null,
                      setEmployeeDataAdd,
                      employeeDataAdd
                    )}
                    InputProps={{
                      startAdornment: <InputAdornment position="start">Rp</InputAdornment>,
                      inputProps: {
                        step: "0.01",
                        min: "0"
                      }
                    }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    type="number"
                    label="Position Assistance"
                    value={employeeDataAdd.positionAllowance}
                    name="positionAllowance"
                    onChange={(e) => handleSalaryChangeAdd(
                      'positionAllowance',
                      parseFloat(e.target.value) || null,
                      setEmployeeDataAdd,
                      employeeDataAdd
                    )}
                    InputProps={{
                      startAdornment: <InputAdornment position="start">Rp</InputAdornment>,
                      inputProps: {
                        step: "0.01",
                        min: "0"
                      }
                    }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    type="number"
                    label="Mobile Phone Assistance"
                    value={employeeDataAdd.mobilePhoneAllowance}
                    name="mobilePhoneAllowance"
                    onChange={(e) => handleSalaryChangeAdd(
                      'mobilePhoneAllowance',
                      parseFloat(e.target.value) || null,
                      setEmployeeDataAdd,
                      employeeDataAdd
                    )}
                    InputProps={{
                      startAdornment: <InputAdornment position="start">Rp</InputAdornment>,
                      inputProps: {
                        step: "0.01",
                        min: "0"
                      }
                    }}
                  />
                </Grid>
                {/* <Grid item xs={6}>
                  <TextField
                    fullWidth
                    type="number"
                    label="Overtime Assistance"
                    value={employeeDataAdd.overtimeAllowance}
                    name="overtimeAllowance"
                    onChange={(e) => handleSalaryChangeAdd(
                      'overtimeAllowance',
                      parseFloat(e.target.value) || null,
                      setEmployeeDataAdd,
                      employeeDataAdd
                    )}
                    InputProps={{
                      startAdornment: <InputAdornment position="start">Rp</InputAdornment>,
                      inputProps: {
                        step: "0.01",
                        min: "0"
                      }
                    }}
                  />
                </Grid> */}
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    type="number"
                    label="Natura Assistance"
                    value={employeeDataAdd.naturaAllowance}
                    name="naturaAllowance"
                    onChange={(e) => handleSalaryChangeAdd(
                      'naturaAllowance',
                      parseFloat(e.target.value) || null,
                      setEmployeeDataAdd,
                      employeeDataAdd
                    )}
                    InputProps={{
                      startAdornment: <InputAdornment position="start">Rp</InputAdornment>,
                      inputProps: {
                        step: "0.01",
                        min: "0"
                      }
                    }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    type="number"
                    label="Other Assistance"
                    value={employeeDataAdd.otherAllowance}
                    name="otherAllowance"
                    onChange={(e) => handleSalaryChangeAdd(
                      'otherAllowance',
                      parseFloat(e.target.value) || null,
                      setEmployeeDataAdd,
                      employeeDataAdd
                    )}
                    InputProps={{
                      startAdornment: <InputAdornment position="start">Rp</InputAdornment>,
                      inputProps: {
                        step: "0.01",
                        min: "0"
                      }
                    }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    label="BPJS Kesehatan (1%)"
                    value={formatCurrency(employeeDataAdd.bpjsKesehatan) || ''}
                    name="bpjsKesehatan"
                    disabled
                    InputProps={{
                      startAdornment: <InputAdornment position="start">Rp</InputAdornment>,
                    }}
                    helperText="1% dari gaji pokok (maks Rp120.000/bulan)"
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    label="BPJS TK (3%)"
                    value={formatCurrency(employeeDataAdd.bpjsTK) || ''}
                    name="bpjsTK"
                    disabled
                    InputProps={{
                      startAdornment: <InputAdornment position="start">Rp</InputAdornment>,
                    }}
                    helperText="2% JHT + 1% JP dari gaji pokok"
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    select
                    fullWidth
                    label="Category PTKP"
                    value={employeeDataAdd.pTKPCategory || ""} // Tambahkan fallback
                    name="pTKPCategory"
                    error={!employeeDataAdd.pTKPCategory}
                    helperText={
                      !employeeDataAdd.pTKPCategory ? "Mandatory Field" : ""
                    }
                    onChange={handlePTKPChangeAdd} // Gunakan handler yang benar
                  >
                    <MenuItem value="" disabled>
                      Select item
                    </MenuItem>
                    <MenuItem value="TK/0">TK/0 - Tidak Kawin dan Tidak Ada Tanggungan</MenuItem>
                    <MenuItem value="TK/1">TK/1 - Tidak Kawin dengan Satu Tanggungan</MenuItem>
                    <MenuItem value="TK/2">TK/2 - Tidak Kawin dengan Dua Tanggungan</MenuItem>
                    <MenuItem value="TK/3">TK/3 - Tidak Kawin dengan Tiga Tanggungan</MenuItem>
                    <MenuItem value="K/0">K/0 - Kawin dan Tidak Ada Tanggungan</MenuItem>
                    <MenuItem value="K/1">K/1 - Kawin dengan Satu Tanggungan</MenuItem>
                    <MenuItem value="K/2">K/2 - Kawin dengan Dua Tanggungan</MenuItem>
                    <MenuItem value="K/3">K/3 - Kawin dengan Tiga Tanggungan</MenuItem>
                  </TextField>
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    label="Category TER"
                    value={employeeDataAdd.categoryTER}
                    disabled
                    InputProps={{
                      readOnly: true,
                    }}
                    variant="outlined"
                    helperText="Automatically set based on PTKP category"
                  />
                </Grid>
                {/* <Grid item xs={6}>
                  <TextField
                    fullWidth
                    label="PPH21"
                    value={formatCurrency(employeeDataAdd.pph21)}
                    disabled
                    InputProps={{
                      startAdornment: <InputAdornment position="start"></InputAdornment>,
                      readOnly: true,
                    }}
                    variant="outlined"
                  />
                </Grid> */}
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    label="Gross Salary"
                    value={formatCurrency(employeeDataAdd.grossSalary)}
                    disabled
                    InputProps={{
                      startAdornment: <InputAdornment position="start"></InputAdornment>,
                      readOnly: true,
                    }}
                    variant="outlined"
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    label="Bayar Pegawai"
                    value={formatCurrency(employeeDataAdd.nettSalary)}
                    disabled
                    InputProps={{
                      startAdornment: <InputAdornment position="start"></InputAdornment>,
                      readOnly: true,
                    }}
                    variant="outlined"
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </DialogContent>

        {/* Buttons: Save & Close */}
        <DialogActions
          sx={{ display: "flex", justifyContent: "space-between", mt: 2 }}
        >
          <Button variant="outlined" color="error" onClick={handleCloseAdd}>
            Cancel
          </Button>
          <Button variant="contained" color="success" onClick={handleSaveAdd}>
            Save
          </Button>
        </DialogActions>
      </Dialog>

      {/* ================================ POPUP Edit Vendor ======================================*/}
      <Dialog
        open={openEditEmployeeDialog}
        onClose={() => setOpenEditEmployeeDialog(false)}
        fullWidth
        maxWidth="lg"
        sx={{ backdropFilter: "blur(5px)" }}
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="h6" fontWeight="bold">
            Detail Employee
          </Typography>
          <IconButton onClick={handleCloseEdit} color="error">
            <Close />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={3}>
            {/* Profile Picture & Employee ID */}
            <Grid item xs={12} sm={4}>
              <Typography variant="subtitle1" fontWeight="bold">
                PERSONAL DETAILS
              </Typography>
              <Box
                sx={{
                  flex: 1,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  border: "2px dashed #aaa",
                  padding: 4,
                  borderRadius: "12px",
                  backgroundColor: "#fafafa",
                  textAlign: "center",
                  cursor: "pointer",
                  position: "relative",
                }}
                disabled={!isEditing}
                onDragOver={(e) => e.preventDefault()}
                onDrop={(e) => {
                  if (isEditing) {
                    e.preventDefault();
                    const file = e.dataTransfer.files[0];
                    handleEditFileUpload(file);
                  }
                }}
                onClick={() => {
                  if (isEditing) {
                    editFileInputRef.current?.click();
                  }
                }}
              >
                {employeeDataEdit.file ? (
                  <img
                    src={URL.createObjectURL(employeeDataEdit.file)}
                    alt="Preview"
                    style={{
                      width: "100%",
                      height: "auto",
                      borderRadius: "8px",
                      objectFit: "contain",
                      maxHeight: 180,
                    }}
                  />
                ) : !!employeeDataEdit.previewUrl ? (
                  <img
                    src={employeeDataEdit.previewUrl}
                    alt="Existing"
                    style={{
                      width: "100%",
                      height: "auto",
                      borderRadius: "8px",
                      objectFit: "contain",
                      maxHeight: 180,
                    }}
                  />
                ) : (
                  <>
                    <PhotoCamera fontSize="large" />
                    <Typography variant="body2" color="textSecondary" mt={1}>
                      Drag & drop or click to upload image
                    </Typography>
                  </>
                )}

                <input
                  hidden
                  accept="image/png, image/jpeg, image/jpg"
                  type="file"
                  ref={editFileInputRef}
                  onChange={(e) => handleEditFileUpload(e.target.files[0])}
                />
                <Typography variant="caption" mt={1}>
                  Max size: 5MB (.png, .jpg, .jpeg)
                </Typography>
              </Box>

              <TextField
                fullWidth
                label="Employee Name"
                value={employeeDataEdit.name}
                sx={{ mb: 1, mt: 1 }}
                name="name"
                disabled={!isEditing}
                error={isEditing && !employeeDataEdit.name}
                helperText={
                  isEditing && !employeeDataEdit.name ? "Mandatory Field" : ""
                }
                onChange={handleInputChangeEdit}
              />
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DesktopDatePicker
                  label="Date Of Birth"
                  format="YYYY-MM-DD"
                  disabled={!isEditing}
                  value={
                    employeeDataEdit.dateOfBirth
                      ? dayjs(employeeDataEdit.dateOfBirth)
                      : null
                  }
                  onChange={(newValue) =>
                    handleInputChangeEdit({
                      target: {
                        name: "dateOfBirth",
                        value: newValue
                          ? dayjs(newValue).format("YYYY-MM-DD")
                          : "",
                      },
                    })
                  }
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      sx: { mb: 1 },
                      name: "dateOfBirth",
                      error: isEditing && !employeeDataEdit.dateOfBirth,
                      helperText:
                        isEditing && !employeeDataEdit.dateOfBirth
                          ? "Mandatory Field"
                          : "",
                    },
                  }}
                />
              </LocalizationProvider>
              <TextField
                fullWidth
                label="Place Of Birth"
                value={employeeDataEdit.cityOfBirth}
                sx={{ mb: 1 }}
                name="cityOfBirth"
                disabled={!isEditing}
                error={isEditing && !employeeDataEdit.cityOfBirth}
                helperText={
                  isEditing && !employeeDataEdit.cityOfBirth
                    ? "Mandatory Field"
                    : ""
                }
                onChange={handleInputChangeEdit}
              />
              <TextField
                select
                fullWidth
                label="Religion"
                value={employeeDataEdit.religion}
                name="religion"
                error={!employeeDataEdit.religion}
                disabled={!isEditing}
                helperText={
                  isEditing && !employeeDataEdit.religion
                    ? "Mandatory Field"
                    : ""
                }
                onChange={handleInputChangeEdit}
                sx={{ mb: 1 }}
              >
                <MenuItem value="" disabled>
                  Select item
                </MenuItem>
                <MenuItem value="Islam">Islam</MenuItem>
                <MenuItem value="Christian">Kristen Protestan</MenuItem>
                <MenuItem value="Catholic">Kristen Katolik</MenuItem>
                <MenuItem value="Hindu">Hindu</MenuItem>
                <MenuItem value="Buddha">Buddha</MenuItem>
                <MenuItem value="Konghucu">Konghucu</MenuItem>
              </TextField>
              <TextField
                fullWidth
                multiline
                rows={3}
                label="Address"
                value={employeeDataEdit.address}
                sx={{ mb: 1 }}
                name="address"
                disabled={!isEditing}
                error={isEditing && !employeeDataEdit.address}
                helperText={
                  isEditing && !employeeDataEdit.address
                    ? "Mandatory Field"
                    : ""
                }
                onChange={handleInputChangeEdit}
              />
              <TextField
                fullWidth
                type="number"
                label="Phone Number"
                value={employeeDataEdit.phone}
                sx={{ mb: 1 }}
                name="phone"
                disabled={!isEditing}
                error={isEditing && !employeeDataEdit.phone}
                helperText={
                  isEditing && !employeeDataEdit.phone ? "Mandatory Field" : ""
                }
                onChange={handleInputChangeEdit}
              />

              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <TextField
                    select
                    fullWidth
                    label="Gender"
                    value={employeeDataEdit.gender}
                    name="gender"
                    disabled={!isEditing}
                    error={isEditing && !employeeDataEdit.gender}
                    helperText={
                      isEditing && !employeeDataEdit.gender
                        ? "Mandatory Field"
                        : ""
                    }
                    onChange={handleInputChangeEdit}
                  >
                    <MenuItem value="" disabled>
                      Select item
                    </MenuItem>
                    <MenuItem value="Male">Laki-Laki</MenuItem>
                    <MenuItem value="Female">Perempuan</MenuItem>
                  </TextField>
                </Grid>
                {/* <Grid item xs={6}>
                  <TextField
                    select
                    fullWidth
                    label="Marital Status"
                    value={employeeDataEdit.maritalStatus}
                    name="maritalStatus"
                    disabled={!isEditing}
                    error={isEditing && !employeeDataEdit.maritalStatus}
                    helperText={
                      isEditing && !employeeDataEdit.maritalStatus
                        ? "Mandatory Field"
                        : ""
                    }
                    onChange={handleInputChangeEdit}
                  >
                    <MenuItem value="" disabled>
                      Select item
                    </MenuItem>
                    <MenuItem value="Single">Belum Menikah</MenuItem>
                    <MenuItem value="Married">Menikah</MenuItem>
                    <MenuItem value="Widow">Widow</MenuItem>
                    <MenuItem value="Widower">Widower</MenuItem>
                  </TextField>
                </Grid>
                {(employeeDataEdit.maritalStatus === "Married" ||
                  employeeDataEdit.maritalStatus === "Widow" ||
                  employeeDataEdit.maritalStatus === "Widower") && (
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        type="number"
                        label="Total Jumlah Anak"
                        sx={{ mb: 1 }}
                        value={employeeDataEdit.totalAnak}
                        name="totalAnak"
                        error={isEditing && !employeeDataEdit.totalAnak}
                        disabled={!isEditing}
                        helperText={
                          isEditing && !employeeDataEdit.totalAnak
                            ? "Mandatory Field"
                            : ""
                        }
                        onChange={handleInputChangeEdit}
                      />
                    </Grid>
                  )} */}
              </Grid>
            </Grid>

            {/* Personal Details & Employment Profile */}
            <Grid item xs={12} sm={8}>
              <Grid container spacing={2}>
                {/* Personal Details */}
                <Grid item xs={12} sm={6}>
                  <Typography variant="subtitle1" fontWeight="bold">
                    EMPLOYMENT PROFILE
                  </Typography>
                  <TextField
                    fullWidth
                    label="Nomor Induk Karyawan"
                    value={employeeDataEdit.nik}
                    name="nik"
                    onChange={handleInputChangeEdit}
                    disabled
                    error={isEditing && !employeeDataEdit.nik}
                    helperText={
                      isEditing && !employeeDataEdit.nik
                        ? "Mandatory Field"
                        : ""
                    }
                    sx={{ mt: 1 }}
                  />
                  {/* Role Multi-Select */}
                  <Grid item xs={24} md={12} mb={2}>
                    <Box
                      sx={{
                        border: "1px solid",
                        borderColor: "divider",
                        borderRadius: 2,
                        p: 2,
                        height: "100%",
                        display: "flex",
                        flexDirection: "column",
                        gap: 2,
                        mt: 2,
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <Typography
                          variant="subtitle1"
                          fontWeight="bold"
                          color="text.secondary"
                        >
                          Assigned Permissions
                        </Typography>
                        {isEditing && (
                          <Typography variant="caption" color="text.secondary">
                            {employeeDataEdit.position?.length || 0} permissions
                          </Typography>
                        )}
                      </Box>

                      <Box
                        sx={{
                          flexGrow: 1,
                          maxHeight: 300,
                          overflowY: "auto",
                          p: 1,
                          backgroundColor: "background.default",
                          borderRadius: 1,
                          border: "1px solid",
                          borderColor: "divider",
                          minHeight: 100,
                        }}
                      >
                        {(employeeDataEdit.position || []).length > 0 ? (
                          <Grid container spacing={1}>
                            {employeeDataEdit.position.map((roleId, index) => {
                              const role = roles.find((r) => r.id === roleId);
                              return (
                                <Grid item xs={12} sm={6} key={index}>
                                  <Chip
                                    label={role?.name || roleId}
                                    onDelete={
                                      isEditing
                                        ? () => handleRemoveRoleEdit(index)
                                        : undefined
                                    }
                                    sx={{
                                      width: "100%",
                                      justifyContent: "space-between",
                                      borderRadius: 1,
                                      backgroundColor: isEditing
                                        ? "action.selected"
                                        : "background.paper",
                                      "& .MuiChip-deleteIcon": {
                                        color: "error.main",
                                      },
                                      // Tambahkan ini:
                                      color: isEditing
                                        ? undefined
                                        : "text.secondary",
                                      "& .MuiChip-label": {
                                        color: isEditing
                                          ? undefined
                                          : "text.secondary",
                                      },
                                    }}
                                    clickable={isEditing}
                                  />
                                </Grid>
                              );
                            })}
                          </Grid>
                        ) : (
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                              justifyContent: "center",
                              height: 100,
                              color: "text.disabled",
                            }}
                          >
                            <Typography variant="body2">
                              No role assigned
                            </Typography>
                            {!isEditing && (
                              <Typography variant="caption">
                                Click EDIT to add role
                              </Typography>
                            )}
                          </Box>
                        )}
                      </Box>

                      {isEditing && (
                        <Box
                          sx={{ display: "flex", gap: 1, alignItems: "center" }}
                        >
                          <Select
                            fullWidth
                            displayEmpty
                            value={newRole}
                            onChange={(e) =>
                              setNewRole(e.target.value as string)
                            }
                            size="small"
                            sx={{
                              flexGrow: 1,
                              "& .MuiOutlinedInput-root": {
                                borderRadius: 1,
                              },
                            }}
                            disabled={loadingRoles}
                            MenuProps={{
                              PaperProps: {
                                style: {
                                  maxHeight: 300,
                                },
                              },
                              disableEnforceFocus: true,
                              onKeyDown: (e) => {
                                if (
                                  document.activeElement.id ===
                                  "role-search-input-edit"
                                ) {
                                  e.stopPropagation();
                                }
                              },
                            }}
                            onOpen={() => {
                              setTimeout(() => {
                                const searchInput = document.getElementById(
                                  "role-search-input-edit"
                                );
                                if (searchInput) {
                                  searchInput.focus();
                                }
                              }, 100);
                            }}
                          >
                            {/* Search Field */}
                            <Box
                              sx={{ p: 1 }}
                              onClick={(e) => e.stopPropagation()}
                            >
                              <TextField
                                id="role-search-input-edit"
                                fullWidth
                                variant="outlined"
                                placeholder="Search roles..."
                                value={roleSearchEdit}
                                onChange={(e) =>
                                  setRoleSearchEdit(e.target.value)
                                }
                                onClick={(e) => {
                                  e.stopPropagation();
                                  e.currentTarget.focus();
                                }}
                                onKeyDown={(e) => e.stopPropagation()}
                                InputProps={{
                                  startAdornment: (
                                    <InputAdornment position="start">
                                      <Search fontSize="small" />
                                    </InputAdornment>
                                  ),
                                  endAdornment: roleSearchEdit && (
                                    <InputAdornment position="end">
                                      <IconButton
                                        size="small"
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          setRoleSearchEdit("");
                                        }}
                                      >
                                        <Clear fontSize="small" />
                                      </IconButton>
                                    </InputAdornment>
                                  ),
                                  size: "small",
                                }}
                                sx={{
                                  "& .MuiOutlinedInput-root": {
                                    paddingRight: 1,
                                  },
                                }}
                                autoFocus
                              />
                            </Box>

                            {/* Filtered Role List */}
                            {roles
                              .filter((role) => {
                                // Filter by search and exclude already assigned roles
                                const matchesSearch =
                                  role.name
                                    .toLowerCase()
                                    .includes(roleSearchEdit.toLowerCase()) ||
                                  role.id
                                    .toLowerCase()
                                    .includes(roleSearchEdit.toLowerCase());
                                const notAssigned =
                                  !employeeDataEdit.position?.includes(role.id);
                                return matchesSearch && notAssigned;
                              })
                              .map((role) => (
                                <MenuItem key={role.id} value={role.name}>
                                  {role.name}
                                </MenuItem>
                              ))}

                            {roles.filter((role) => {
                              const matchesSearch =
                                role.name
                                  .toLowerCase()
                                  .includes(roleSearchEdit.toLowerCase()) ||
                                role.id
                                  .toLowerCase()
                                  .includes(roleSearchEdit.toLowerCase());
                              const notAssigned =
                                !employeeDataEdit.position?.includes(role.id);
                              return matchesSearch && notAssigned;
                            }).length === 0 && (
                                <MenuItem disabled>
                                  <Typography
                                    variant="body2"
                                    color="text.secondary"
                                  >
                                    No roles found
                                  </Typography>
                                </MenuItem>
                              )}
                          </Select>
                          <Button
                            variant="contained"
                            onClick={handleAddRoleEdit}
                            disabled={!newRole}
                            sx={{
                              minWidth: 120,
                              height: 40,
                              borderRadius: 1,
                              textTransform: "none",
                            }}
                          >
                            Add
                          </Button>
                        </Box>
                      )}
                    </Box>
                  </Grid>
                  <TextField
                    fullWidth
                    label="Email"
                    value={employeeDataEdit.email}
                    sx={{ mb: 1 }}
                    name="email"
                    disabled={!isEditing}
                    error={isEditing && !employeeDataEdit.email}
                    helperText={
                      isEditing && !employeeDataEdit.email
                        ? "Mandatory Field"
                        : ""
                    }
                    onChange={handleInputChangeEdit}
                  />
                  {/* Directorate Field */}
                  <TextField
                    select
                    fullWidth
                    label="Directorate"
                    sx={{ textAlign: "left", mt: 1 }}
                    value={employeeDataEdit.directorate}
                    name="directorate"
                    disabled={!isEditing}
                    error={isEditing && !employeeDataEdit.directorate}
                    helperText={
                      isEditing && !employeeDataEdit.directorate
                        ? "Mandatory Field"
                        : ""
                    }
                    onChange={handleDirectorateChangeEdit}
                  >
                    <MenuItem value="" disabled>
                      Select Directorate
                    </MenuItem>
                    {Object.keys(positionData).map((directorate) => (
                      <MenuItem key={directorate} value={directorate}>
                        {directorate}
                      </MenuItem>
                    ))}
                  </TextField>

                  {/* Division Field */}
                  <TextField
                    select
                    fullWidth
                    label="Division"
                    sx={{ textAlign: "left", mt: 1 }}
                    value={employeeDataEdit.division}
                    name="division"
                    error={isEditing && !employeeDataEdit.division}
                    helperText={
                      isEditing && !employeeDataEdit.division
                        ? "Mandatory Field"
                        : ""
                    }
                    onChange={handleDivisionChangeEdit}
                    disabled={!isEditing || !employeeDataEdit.directorate}
                  >
                    <MenuItem value="" disabled>
                      Select Division
                    </MenuItem>

                    {divisionsEdit.map((division) => (
                      <MenuItem key={division} value={division}>
                        {division}
                      </MenuItem>
                    ))}
                  </TextField>

                  {/* Job Title Field */}
                  <TextField
                    select
                    fullWidth
                    label="Job Title"
                    sx={{ textAlign: "left", mt: 1 }}
                    value={employeeDataEdit.jobTitle}
                    name="jobTitle"
                    error={isEditing && !employeeDataEdit.jobTitle}
                    helperText={
                      isEditing && !employeeDataEdit.jobTitle
                        ? "Mandatory Field"
                        : ""
                    }
                    onChange={handleJobTitleChangeEdit}
                    disabled={!isEditing || !employeeDataEdit.division}
                  >
                    <MenuItem value="" disabled>
                      Select Job Title
                    </MenuItem>

                    {jobTitlesEdit.map((jobTitle) => (
                      <MenuItem key={jobTitle} value={jobTitle}>
                        {jobTitle}
                      </MenuItem>
                    ))}
                  </TextField>
                  <Grid container spacing={2}>
                    <Grid item xs={6}>
                      <TextField
                        select
                        fullWidth
                        label="Status"
                        sx={{ mt: 1 }}
                        disabled={!isEditing}
                        value={employeeDataEdit.status}
                        name="status"
                        error={isEditing && !employeeDataEdit.status}
                        helperText={
                          isEditing && !employeeDataEdit.status
                            ? "Mandatory Field"
                            : ""
                        }
                        onChange={handleInputChangeEdit}
                      >
                        <MenuItem value="" disabled>
                          Select item
                        </MenuItem>
                        <MenuItem value="Active">Active</MenuItem>
                        <MenuItem value="Probation">Probation</MenuItem>
                        <MenuItem value="Contract">Contract</MenuItem>
                        <MenuItem value="Resign">Resign</MenuItem>
                      </TextField>
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        select
                        fullWidth
                        label="Employee Type"
                        sx={{ mt: 1 }}
                        disabled={!isEditing}
                        value={employeeDataEdit.employeeType}
                        name="employeeType"
                        error={isEditing && !employeeDataEdit.employeeType}
                        helperText={
                          isEditing && !employeeDataEdit.employeeType
                            ? "Mandatory Field"
                            : ""
                        }
                        onChange={handleInputChangeEdit}
                      >
                        <MenuItem value="" disabled>
                          Select item
                        </MenuItem>
                        <MenuItem value="Organic">Organic</MenuItem>
                        <MenuItem value="Inorganic">Inorganic</MenuItem>
                      </TextField>
                    </Grid>
                  </Grid>
                  <Autocomplete
                    options={offices}
                    getOptionLabel={(option) => option.officeName || ""}
                    value={
                      offices.find(
                        (o) => o.officeId === employeeDataEdit.office
                      ) || null
                    }
                    onChange={(event, newValue) => {
                      handleInputChangeEdit({
                        target: {
                          name: "office",
                          value: newValue ? newValue.officeId : "",
                        },
                      });
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Office"
                        placeholder="Select Office"
                        margin="normal"
                        fullWidth
                        sx={{ mt: 1 }}
                        error={isEditing && !employeeDataEdit.office}
                        helperText={
                          isEditing && !employeeDataEdit.office
                            ? "Mandatory Field"
                            : ""
                        }
                        disabled={!isEditing || loadingOffices}
                      />
                    )}
                    loading={loadingOffices}
                    loadingText="Loading offices..."
                    noOptionsText={
                      offices.length === 0
                        ? "No offices available"
                        : "No matching offices found"
                    }
                    disabled={!isEditing}
                  />
                  {employeeDataEdit.employeeType === "Inorganic" && (
                    <Autocomplete
                      options={vendors}
                      getOptionLabel={(option) => option.vendorName || ""}
                      value={
                        vendors.find(
                          (v) => v.vendorId === employeeDataEdit.company
                        ) || null
                      }
                      onChange={(event, newValue) => {
                        handleInputChangeEdit({
                          target: {
                            name: "company",
                            value: newValue ? newValue.vendorId : "",
                          },
                        });
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Vendor Company"
                          placeholder="Select Vendor"
                          margin="normal"
                          fullWidth
                          sx={{ mt: 1 }}
                          error={isEditing && !employeeDataEdit.company}
                          helperText={
                            isEditing && !employeeDataEdit.company
                              ? "Mandatory Field"
                              : ""
                          }
                          disabled={!isEditing || loadingVendors}
                        />
                      )}
                      loading={loadingVendors}
                      loadingText="Loading vendors..."
                      noOptionsText={
                        vendors.length === 0
                          ? "No vendors available"
                          : "No matching vendors found"
                      }
                      disabled={!isEditing}
                    />
                  )}
                </Grid>

                {/* Employment Profile */}
                <Grid item xs={12} sm={6}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DesktopDatePicker
                      label="Date Joining"
                      format="YYYY-MM-DD"
                      disabled={!isEditing}
                      value={
                        employeeDataEdit.dateOfJoining
                          ? dayjs(employeeDataEdit.dateOfJoining)
                          : null
                      }
                      onChange={(newValue) =>
                        handleInputChangeEdit({
                          target: {
                            name: "dateOfJoining",
                            value: newValue
                              ? dayjs(newValue).format("YYYY-MM-DD")
                              : "",
                          },
                        })
                      }
                      slotProps={{
                        textField: {
                          fullWidth: true,
                          sx: { mb: 1, mt: 4.5 },
                          name: "dateOfJoining",
                          error: isEditing && !employeeDataEdit.dateOfJoining,
                          helperText:
                            isEditing && !employeeDataEdit.dateOfJoining
                              ? "Mandatory Field"
                              : "",
                        },
                      }}
                    />
                  </LocalizationProvider>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DesktopDatePicker
                      label="End of Contract"
                      format="YYYY-MM-DD"
                      disabled={!isEditing}
                      value={
                        employeeDataEdit.expiredDate
                          ? dayjs(employeeDataEdit.expiredDate)
                          : null
                      }
                      onChange={(newValue) =>
                        handleInputChangeEdit({
                          target: {
                            name: "expiredDate",
                            value: newValue
                              ? dayjs(newValue).format("YYYY-MM-DD")
                              : "",
                          },
                        })
                      }
                      slotProps={{
                        textField: {
                          fullWidth: true,
                          sx: { mb: 1 },
                          error: false,
                          name: "expiredDate",
                        },
                      }}
                    />
                  </LocalizationProvider>
                  <TextField
                    fullWidth
                    multiline
                    rows={3}
                    placeholder="Enter notes"
                    sx={{ textAlign: "left", mt: 1, mb: 2 }}
                    value={employeeDataEdit.notes}
                    name="notes"
                    disabled={!isEditing}
                    onChange={handleInputChangeEdit}
                  />
                </Grid>
              </Grid>
            </Grid>

            {/* Divider - Garis Pemisah */}
            <Grid item xs={12} sm={8}>
              <Divider sx={{ my: 0, borderBottom: "2px solid #ddd" }} />
            </Grid>

            {/* Personal Salary Information */}
            <Grid item xs={12} sm={8}>
              <Typography
                variant="subtitle1"
                fontWeight="bold"
                sx={{ mt: -2, mb: 0.5 }}
              >
                PERSONAL SALARY INFORMATION
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    type="number"
                    label="No NPWP"
                    value={employeeDataEdit.taxIdNumber}
                    name="taxIdNumber"
                    disabled={!isEditing}
                    error={isEditing && !employeeDataEdit.taxIdNumber}
                    helperText={
                      isEditing && !employeeDataEdit.taxIdNumber
                        ? "Mandatory Field"
                        : ""
                    }
                    onChange={handleInputChangeEdit}
                  />
                </Grid>
                <Grid item xs={6}>
                  <Autocomplete
                    options={bankData}
                    value={employeeDataEdit.bankName || null}
                    onChange={(event, newValue) => {
                      handleInputChangeEdit({
                        target: {
                          name: "bankName",
                          value: newValue || "",
                        },
                      });
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Bank Name"
                        placeholder="Select Bank"
                        fullWidth
                        error={isEditing && !employeeDataEdit.bankName}
                        helperText={
                          isEditing && !employeeDataEdit.bankName
                            ? "Mandatory Field"
                            : ""
                        }
                        disabled={!isEditing}
                      />
                    )}
                    noOptionsText="No banks available"
                    disabled={!isEditing}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    type="number"
                    label="Salary"
                    value={employeeDataEdit.salary ?? ''}
                    disabled={!isEditing}
                    onChange={(e) => {
                      handleSalaryChangeEdit('salary', parseFloat(e.target.value) || null, setEmployeeDataEdit, employeeDataEdit);
                    }}
                    InputProps={{
                      startAdornment: <InputAdornment position="start">Rp</InputAdornment>,
                      inputProps: {
                        step: "0.01",
                        min: "0"
                      }
                    }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    type="number"
                    label="Bank Account Number"
                    value={employeeDataEdit.bankNumber}
                    name="bankNumber"
                    disabled={!isEditing}
                    error={isEditing && !employeeDataEdit.bankNumber}
                    helperText={
                      isEditing && !employeeDataEdit.bankNumber
                        ? "Mandatory Field"
                        : ""
                    }
                    onChange={handleInputChangeEdit}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    type="number"
                    label="Salary Coefficient"
                    value={employeeDataEdit.salaryCoefficient ?? ''}
                    disabled={!isEditing}
                    name="salaryCoefficient"
                    onChange={(e) => {
                      handleSalaryChangeEdit('salaryCoefficient', e.target.value, setEmployeeDataEdit, employeeDataEdit);
                    }}
                    inputProps={{
                      step: "0.01",
                      min: "1",
                    }}
                    helperText="minimal 1%"
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    label="Bank Account Name"
                    value={employeeDataEdit.bankAccountName}
                    name="bankAccountName"
                    disabled={!isEditing}
                    error={isEditing && !employeeDataEdit.bankAccountName}
                    helperText={
                      isEditing && !employeeDataEdit.bankAccountName
                        ? "Mandatory Field"
                        : ""
                    }
                    onChange={handleInputChangeEdit}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    type="number"
                    label="Salary Delta"
                    value={employeeDataEdit.salaryDelta ?? ''}
                    disabled={!isEditing}
                    name="salaryDelta"
                    onChange={(e) => {
                      handleSalaryChangeEdit('salaryDelta', e.target.value, setEmployeeDataEdit, employeeDataEdit);
                    }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    type="number"
                    label="Contribution Allowance"
                    value={employeeDataEdit.contributionAllowance ?? ''}
                    disabled={!isEditing}
                    name="contributionAllowance"
                    onChange={(e) => {
                      handleSalaryChangeEdit('contributionAllowance', parseFloat(e.target.value) || null, setEmployeeDataEdit, employeeDataEdit);
                    }}
                    InputProps={{
                      startAdornment: <InputAdornment position="start">Rp</InputAdornment>,
                      inputProps: {
                        step: "0.01",
                        min: "0"
                      }
                    }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    type="number"
                    label="Service Allowance"
                    value={employeeDataEdit.serviceAllowance ?? ''}
                    disabled={!isEditing}
                    name="serviceAllowance"
                    onChange={(e) => handleSalaryChangeEdit(
                      'serviceAllowance',
                      parseFloat(e.target.value) || null,
                      setEmployeeDataEdit,
                      employeeDataEdit
                    )}
                    InputProps={{
                      startAdornment: <InputAdornment position="start">Rp</InputAdornment>,
                      inputProps: {
                        step: "0.01",
                        min: "0"
                      }
                    }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    type="number"
                    label="Coaching Assistance"
                    value={employeeDataEdit.coachingAllowance}
                    disabled={!isEditing}
                    name="coachingAllowance"
                    onChange={(e) => handleSalaryChangeEdit(
                      'coachingAllowance',
                      parseFloat(e.target.value) || null,
                      setEmployeeDataEdit,
                      employeeDataEdit
                    )}
                    InputProps={{
                      startAdornment: <InputAdornment position="start">Rp</InputAdornment>,
                      inputProps: {
                        step: "0.01",
                        min: "0"
                      }
                    }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    type="number"
                    label="Transport Assistance"
                    value={employeeDataEdit.transportAllowance}
                    disabled={!isEditing}
                    name="transportAllowance"
                    onChange={(e) => handleSalaryChangeEdit(
                      'transportAllowance',
                      parseFloat(e.target.value) || null,
                      setEmployeeDataEdit,
                      employeeDataEdit
                    )}
                    InputProps={{
                      startAdornment: <InputAdornment position="start">Rp</InputAdornment>,
                      inputProps: {
                        step: "0.01",
                        min: "0"
                      }
                    }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    type="number"
                    label="Housing Assistance"
                    value={employeeDataEdit.housingAllowance}
                    disabled={!isEditing}
                    name="housingAllowance"
                    onChange={(e) => handleSalaryChangeEdit(
                      'housingAllowance',
                      parseFloat(e.target.value) || null,
                      setEmployeeDataEdit,
                      employeeDataEdit
                    )}
                    InputProps={{
                      startAdornment: <InputAdornment position="start">Rp</InputAdornment>,
                      inputProps: {
                        step: "0.01",
                        min: "0"
                      }
                    }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    type="number"
                    label="Telecommunication Assistance"
                    value={employeeDataEdit.telecommunicationAllowance}
                    disabled={!isEditing}
                    name="telecommunicationAllowance"
                    onChange={(e) => handleSalaryChangeEdit(
                      'telecommunicationAllowance',
                      parseFloat(e.target.value) || null,
                      setEmployeeDataEdit,
                      employeeDataEdit
                    )}
                    InputProps={{
                      startAdornment: <InputAdornment position="start">Rp</InputAdornment>,
                      inputProps: {
                        step: "0.01",
                        min: "0"
                      }
                    }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    type="number"
                    label="Position Assistance"
                    value={employeeDataEdit.positionAllowance}
                    disabled={!isEditing}
                    name="positionAllowance"
                    onChange={(e) => handleSalaryChangeEdit(
                      'positionAllowance',
                      parseFloat(e.target.value) || null,
                      setEmployeeDataEdit,
                      employeeDataEdit
                    )}
                    InputProps={{
                      startAdornment: <InputAdornment position="start">Rp</InputAdornment>,
                      inputProps: {
                        step: "0.01",
                        min: "0"
                      }
                    }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    type="number"
                    label="Mobile Phone Assistance"
                    value={employeeDataEdit.mobilePhoneAllowance}
                    disabled={!isEditing}
                    name="mobilePhoneAllowance"
                    onChange={(e) => handleSalaryChangeEdit(
                      'mobilePhoneAllowance',
                      parseFloat(e.target.value) || null,
                      setEmployeeDataEdit,
                      employeeDataEdit
                    )}
                    InputProps={{
                      startAdornment: <InputAdornment position="start">Rp</InputAdornment>,
                      inputProps: {
                        step: "0.01",
                        min: "0"
                      }
                    }}
                  />
                </Grid>
                {/* <Grid item xs={6}>
                  <TextField
                    fullWidth
                    type="number"
                    label="Overtime Assistance"
                    value={employeeDataEdit.overtimeAllowance}
                    disabled={!isEditing}
                    name="overtimeAllowance"
                    onChange={(e) => handleSalaryChangeEdit(
                      'overtimeAllowance',
                      parseFloat(e.target.value) || null,
                      setEmployeeDataEdit,
                      employeeDataEdit
                    )}
                    InputProps={{
                      startAdornment: <InputAdornment position="start">Rp</InputAdornment>,
                      inputProps: {
                        step: "0.01",
                        min: "0"
                      }
                    }}
                  />
                </Grid> */}
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    type="number"
                    label="Natura Assistance"
                    value={employeeDataEdit.naturaAllowance}
                    disabled={!isEditing}
                    name="naturaAllowance"
                    onChange={(e) => handleSalaryChangeEdit(
                      'naturaAllowance',
                      parseFloat(e.target.value) || null,
                      setEmployeeDataEdit,
                      employeeDataEdit
                    )}
                    InputProps={{
                      startAdornment: <InputAdornment position="start">Rp</InputAdornment>,
                      inputProps: {
                        step: "0.01",
                        min: "0"
                      }
                    }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    type="number"
                    label="Other Assistance"
                    value={employeeDataEdit.otherAllowance ?? ''}
                    disabled={!isEditing}
                    name="otherAllowance"
                    onChange={(e) => handleSalaryChangeEdit(
                      'otherAllowance',
                      parseFloat(e.target.value) || null,
                      setEmployeeDataEdit,
                      employeeDataEdit
                    )}
                    InputProps={{
                      startAdornment: <InputAdornment position="start">Rp</InputAdornment>,
                      inputProps: {
                        step: "0.01",
                        min: "0"
                      }
                    }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    label="BPJS Kesehatan (1%)"
                    value={formatCurrency(employeeDataEdit.bpjsKesehatan) ?? ''}
                    name="bpjsKesehatan"
                    disabled
                    InputProps={{
                      startAdornment: <InputAdornment position="start">Rp</InputAdornment>,
                    }}
                    helperText="1% dari gaji pokok (maks Rp120.000/bulan)"
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    label="BPJS TK (3%)"
                    value={formatCurrency(employeeDataEdit.bpjsTK) ?? ''}
                    disabled
                    InputProps={{
                      startAdornment: <InputAdornment position="start">Rp</InputAdornment>,
                    }}
                    variant="outlined"
                    helperText="2% JHT + 1% JP dari gaji pokok"
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    select
                    fullWidth
                    label="Category PTKP"
                    value={employeeDataEdit.pTKPCategory || ""} // Pastikan ada fallback
                    disabled={!isEditing}
                    name="pTKPCategory"
                    error={isEditing && !employeeDataEdit.pTKPCategory}
                    helperText={
                      isEditing && !employeeDataEdit.pTKPCategory
                        ? "Mandatory Field"
                        : ""
                    }
                    onChange={handlePTKPChangeEdit} // Pastikan handler sudah benar
                  >
                    <MenuItem value="" disabled>
                      Select item
                    </MenuItem>
                    <MenuItem value="TK/0">TK/0 - Tidak Kawin dan Tidak Ada Tanggungan</MenuItem>
                    <MenuItem value="TK/1">TK/1 - Tidak Kawin dengan Satu Tanggungan</MenuItem>
                    <MenuItem value="TK/2">TK/2 - Tidak Kawin dengan Dua Tanggungan</MenuItem>
                    <MenuItem value="TK/3">TK/3 - Tidak Kawin dengan Tiga Tanggungan</MenuItem>
                    <MenuItem value="K/0">K/0 - Kawin dan Tidak Ada Tanggungan</MenuItem>
                    <MenuItem value="K/1">K/1 - Kawin dengan Satu Tanggungan</MenuItem>
                    <MenuItem value="K/2">K/2 - Kawin dengan Dua Tanggungan</MenuItem>
                    <MenuItem value="K/3">K/3 - Kawin dengan Tiga Tanggungan</MenuItem>
                  </TextField>
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    label="Category TER"
                    value={employeeDataEdit.categoryTER}
                    disabled
                    InputProps={{
                      readOnly: true,
                    }}
                    variant="outlined"
                    helperText="Automatically set based on PTKP category"
                  />
                </Grid>
                {/* <Grid item xs={6}>
                  <TextField
                    fullWidth
                    label="PPH21"
                    value={formatCurrency(employeeDataEdit.pph21)}
                    disabled
                    InputProps={{
                      startAdornment: <InputAdornment position="start"></InputAdornment>,
                      readOnly: true,
                    }}
                    variant="outlined"
                  />
                </Grid> */}
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    label="Basic Salary"
                    value={formatCurrency(employeeDataEdit.nettSalary)}
                    disabled
                    InputProps={{
                      startAdornment: <InputAdornment position="start"></InputAdornment>,
                      readOnly: true,
                    }}
                    variant="outlined"
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    label="Gross Salary"
                    value={formatCurrency(employeeDataEdit.grossSalary)}
                    disabled
                    InputProps={{
                      startAdornment: <InputAdornment position="start"></InputAdornment>,
                      readOnly: true,
                    }}
                    variant="outlined"
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </DialogContent>

        {/* Buttons: Save & Close */}
        <DialogActions sx={{ justifyContent: "space-between", padding: 2 }}>
          {!isEditing ? (
            // Tombol Edit Muncul di Awal
            <Button
              onClick={() => setIsEditing(true)}
              variant="contained"
              color="primary"
              sx={{ width: 120 }}
            >
              EDIT
            </Button>
          ) : (
            // Tombol Save & Cancel Muncul Saat Edit
            <>
              <Button
                onClick={() => setIsEditing(false)}
                variant="outlined"
                color="error"
                sx={{ width: 120 }}
              >
                CANCEL
              </Button>
              <Button
                onClick={handleSaveEdit}
                variant="contained"
                color="success"
                sx={{ width: 120 }}
              >
                SAVE
              </Button>
            </>
          )}
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default EmployeeListPage;
